{
  "button": {
    "collapse_goods_details": "상품 접기",
    "use_now": "즉시 사용",
    "cancel": "취소",
    "confirm": "확인",
    "get_code": "인증번호 받기",
    "resend_code": "인증번호 재발송",
    "chat_kakao": "카카오 상담",
    "my_address": "배송대행지 주소 가져오기",
    "logout": "로그아웃",
    "address_title": "배송 주소",
    "delivery_fee_chart": "배송비 요율표",
    "address_book": "주소록",
    "search": "검색",
    "tracking_all": "전체 보기",
    "tracking_missing": "트래킹번호 미입력 주문 보기",
    "download_excel": "다운로드",
    "add_tracking": "트래킹번호 추가",
    "use_all_deposit": "예치금 전액 사용",
    "use_all_point": "포인트 전액 사용",
    "use_member_name": "회원명 사용",
    "payment": "결제",
    "reset": "초기화",
    "apply_deposit": "예치금 신청",
    "request_refund": "환불 신청",
    "convert_currency": "위안화 예치금 신청 (위안화 → 원화 환전)",
    "delete": "삭제",
    "mark_as_read": "읽음 표시",
    "close": "닫기",
    "change_password": "비밀번호 변경",
    "select_image": "이미지 선택",
    "edit_info": "정보 수정",
    "withdraw": "회원 탈퇴",
    "edit_btn": "수정",
    "edit": "수정",
    "copy": "복사",

    "add_new_address": "배송지 신규등록",
    "edit_address": "배송지 수정",
    "set_default_address": "기본 주소로 설정",
    "cancel_default_address": "기본 주소로 취소",
    "outbound_return_apply": "원송장반품 신청",
    "use_address": "주소 사용",
    "add": "추가",
    "add_all": "일괄 추가",
    "batch_upload": "일괄 업로드",
    "sku_batch_upload_template": "SKU 일괄 업로드 샘플 다운로드",
    "batch_order": "회송주문 접수",
    "without_track_no_all": "트래킹미입업주문보기",
    "view_all_list": "전체보기",
    "search_zipcode": "우편번호 검색",
    "check_customs_code": "개인통관고유부호 조회",
    "confirm_customs_code": "개인통관고유부호 확인",
    "complete_customs_code_verification": "개인통관고유부호 확인 완료",
    "open_zipcode_popup": "우편번호 검색",
    "submit": "접수신청",
    "edit_recipient_info": "수취인 정보 수정",
    "edit_logistics_info": "물류센터 정보 수정",
    "add_product": "상품 추가",
    "add_sub_tracking": "서브 트래킹번호 추가",
    "back_to_list": "목록으로",
    "back": "뒤로가기",
    "back_to_top": "TOP",
    "view": "보기",
    "more": "더보기",
    "delete_order": "주문삭제",
    "submit_order": "주문접수",
    "proxy_purchase_cancel": "구매취소",
    "load_data": "등록상품 불러오기",
    "history_order_products": "이전 주문 불러오기",
    "get_product_url": "상품 URL 가져오기",
    "copy_order_history": "오더내역복사",
    "copy_cart_history": "장바구니 내역 복사",
    "load_inventory": "재고상품 불러오기",
    "upload_image": "이미지 업로드",
    "register_order": "업로드",
    "customs_clearance_list": "목록통관",
    "simple_customs_clearance": "간이통관",
    "enterprise_customs_clearance": "사업자 통관",
    "customs_clearance_title": "통관 정보",
    "pending_submission": "접수 대기",
    "confirm_submission": "접수 확인",
    "next_step": "다음 단계",
    "get_product_info": "상품 정보 가져오기",
    "export_product_info": "상품 정보 내보내기",
    "save": "저장",
    "view_detail": "상세 보기",
    "split_order": "나눔",
    "merge_order": "묶음",
    "ignore_error": "오류 무시",
    "apply_return": "반품 신청",
    "edit_additional_service": "부가서비스 수정",
    "stock_apply": "재고 신청",
    "stock_out_order": "한국센터 재고출고",
    "purchase_quote": "구매견적",
    "order_apply": "주문 신청",
    "save_completed": "저장 완료",
    "other": "기타",
    "set_add": "세트 추가",
    "set_composition": "세트 구성",
    "img_url": "상품 보기",
    "view_all": "전체보기",
    "temporary_storage": "임시 저장",
    "combined_qty_edit": "합포 수량 변경",
    "order_excel": "주문다운",
    "view_in_details": "입고 내역 보기",
    "view_out_details": "출고 내역 보기",
    "view_details": "내역 보기",
    "expand_package_details": "포장정보 상세보기",
    "collapse_package_details": "포장정보 접기",
    "operation": "작업",
    "apply_cancellation": "폐기 신청",
    "cn_order": "중국센터",
    "kr_order": "한국센터",
    "all_order": "전체 주문",
    "confirm_apply": "신청 확인",
    "order_view": "주문보기",
    "packing_ask_for": "번들요청",
    "issue_handling": "오류처리",
    "check_photo": "실사보기",
    "view_composition": "구성보기",
    "edit_track": "트래킹번호 관리",
    "problem_solving": "오류처리",
    "upload_warehousing_document": "쿠팡입고정보등록",
    "view_warehousing_document": "입고 파일 보기",
    "outbound_request": "출고신청",
    "packing_list": "패킹리스트",
    "packing_detail_download": "포장명세서다운",
    "outbound_real_photos": "출고실사",
    "generate_return_order": "회송주문생성",
    "product_use_conversion": "사용전환",
    "business_license_view": "사업자등록증 파일 보기"
  },
  "errorInStock": {
    "精密确认": "정밀확인",
    "无视错误": "오류무시",
    "重新包装": "재포장",
    "问题入库操作": "오류처리",
    "处理方式": "처리방식",
    "退货信息": "반품정보",
    "退货方式": "방식",
    "使用仓库快递": "센터 택배 이용",
    "卖家回收": "판매자 수거",
    "取件": "수거",
    "取件码": "수거코드",
    "请输入取件码": "수거코드를 입력하세요",
    "取件日期": "수거일",
    "请选择取件日期": "수거 일시를 선택하세요",
    "处理成功": "처리가 완료되었습니다",
    "到货数量有误": "수량오류",
    "商品破损": "상품파손",
    "商品有误": "상품오류",
    "剩余产品": "잔여상품",
    "代买商品编号": "구매상품번호",
    "请选择要操作的商品": "작업할 상품을 선택하세요",
    "请选择要操作的选项": "작업할 옵션을 선택하세요",
    "没有可补发的订单信息": "재발송 가능한 주문 정보가 없습니다",
    "请选择实际补发订单号": "실제 재발송 주문번호를 선택하세요",
    "请先添加处理方式": "처리 방식을 먼저 추가하세요",
    "仅退款": "환불신청",
    "重新检查": "재검수",
    "补发": "재발송"
  },

  "customsClearanceDialog": {
    "titleExpress": "택배 통관 조회",
    "titleLcl": "LCL 통관 조회",
    "titleDefault": "통관 조회",
    "numberExpress": "택배 운송장 번호",
    "numberLcl": "LCL B/L 번호",
    "numberDefault": "조회 번호",
    "cargoExpress": "택배 화물",
    "cargoLcl": "LCL 혼재 화물",
    "cargoDefault": "일반 화물",
    "queryFailed": "통관 정보 조회에 실패했습니다",
    "noData": "조회된 통관 정보가 없습니다",
    "cargoInfo": "화물 정보",
    "cargoName": "품명",
    "cargoType": "화물 유형",
    "hblNo": "HBL 번호",
    "mblNo": "MBL 번호",
    "cargoManagementNo": "화물관리번호",
    "packageCount": "포장수량",
    "totalWeight": "총 중량",
    "weight": "중량",
    "volume": "부피",
    "containerNo": "컨테이너 번호",
    "containerCount": "컨테이너 수량",
    "transportCategory": "운송 분류",
    "transportInfo": "운송 정보",
    "shipName": "선박명",
    "shipNationality": "선박 국적",
    "arrivalDate": "입항일",
    "loadingPort": "적재항",
    "dischargePort": "양하항",
    "arrivalCustoms": "입항 세관",
    "shippingCompany": "선사",
    "forwarder": "포워더",
    "agency": "대리점",
    "lastProcessedAt": "최근 처리 시간",
    "releaseWithinDeadline": "반출의무기간 내 처리",
    "declarationDelaySurtax": "신고 지연 가산세",
    "progress": "통관 진행 정보",
    "progressCount": "총 {count}건",
    "noProgress": "통관 진행 정보가 없습니다",
    "declarationNo": "신고번호",
    "location": "장소",
    "moveDateTime": "반입/반출 일시",
    "locationCode": "장소 코드",
    "basisRemark": "근거/비고",
    "releaseContent": "반출 내용",
    "advanceNotice": "사전 안내",
    "close": "닫기",
    "missingQueryNo": "택배 운송장 번호 또는 LCL B/L 번호가 없어 통관 정보를 조회할 수 없습니다"
  },
  "table": {
    "warehouse_return": "원송장반품",
    "apply_date": "신청일자",
    "resgiter_date": "등록일자",
    "category": "분류",
    "user_name": "작업자",
    "change_amount": "사용금액",
    "deposit_amount": "예치금 잔액",
    "storage_location": "랙번호",
    "split_order_title": "나눔",
    "splite_num_max": "최대 나눔 가능 수",
    "sku_number_available": "사용가능 재고",
    "truck_deliveryService": "포장방식",
    "apply_num_select": "신청 수량 선택",
    "stock_info": "재고 정보",
    "stock_warehouse": "재고 센터",
    "stock_quantity": "재고 수량",
    "avatar": "이미지",
    "product_image": "상품 이미지",
    "spu_product": "등록상품",
    "product_totals": "상품 총수",
    "sku_id_info": "SKU ID 정보",
    "processing": "처리 중",
    "outbound": "출고",
    "outbound_cancel": "출고취소",
    "outbound_return": "원송장반품",
    "order_unit": "개",
    "piece": "개",
    "sku_qty": "SKU 수량",
    "stock_volume": "재고 상품 부피",
    "outbound_qty": "출고수량",
    "order_info": "주문정보",
    "personal_info": "개인정보",
    "order_count": "주문수량",
    "order": "주문",
    "pay_info": "결제정보",

    "address_info": "주소정보",
    "custom_inquiry": "통관조회",
    "customs_type": "통관유형",
    "warehouse": "센터",
    "request_type": "신청유형",
    "receiver_payment": "결제방식",
    "outbound_track_no": "출고 운송장번호",
    "domestic_track_no": "국내 운송장번호",
    "fee": "비용",
    "order_date": "주문/수정 일자",

    "status": "상태",
    "ware_state_cd": "입고상태",
    "state_seq": "주문상태",
    "upd_date": "수정일자",
    "ins_date": "주문일자",
    "create_date": "생성일자",
    "deposit_date": "입금일자",
    "request_date": "신청일자",
    "product_name": "상품명",
    "order_svc_name": "추가 비용명",
    "order_no": "주문번호 / 트래킹번호",
    "color": "색상",
    "size": "사이즈",
    "product_qty": "수량",
    "product_total": "합계",
    "product_status": "상품상태",
    "stock_status": "재고상태",
    "payment_amount": "결제금액",
    "deduction_amount": "차감금액",
    "billing_info": "청구서 정보",
    "application": "신청내역",
    "refund_details": "환불내역",
    "start_date": "시작일자",
    "used_amount": "사용금액",
    "balance_amount": "잔액",
    "today_storage_fee": "오늘 보관료",
    "unpaid_storage_fee_bill_count": "미결제 보관료",
    "no_data": "데이타가 없습니다.",
    "coupon_info": "쿠폰정보",
    "issuance_date": "발급일자",
    "used_date": "사용일자",
    "remaining_days": "잔여일수",
    "days": "일",
    "title": "제목",
    "author": "작성자",
    "write_date": "게시일",
    "read_status": "읽음상태",
    "unread": "안읽음",
    "read": "읽음",
    "shop_order_no": "오더번호",
    "shop_url": "상품 URL",
    "product_url": "상품 URL",
    "image_url": "이미지 URL",
    "customs_item": "통관 품목",
    "price": "단가",
    "total_price": "총 금액",
    "coupang_number": "입고수량",
    "product_memo": "상품메모",
    "product_tax": "상품세율",
    "warehousing_complete": "입고완료",
    "product_comment": "상품 무게/부피",
    "brand": "브랜드",
    "views": "조회수",
    "payment_method": "결제방식",
    "auto_payment": "자동결제",
    "manual_payment": "수동결제",
    "business_platform": "플랫폼 유형",
    "sku_composition": "SKU 구성 정보",
    "age": "14세 미만",
    "limite_term": "유효 기간",
    "sku_select_no": "수량을 입력하세요 (최소 수량 1)",
    "invalid_sku_codes": "SKU가 유효하지 않습니다: {codes}",
    "composition": "구성",
    "processing_date": "처리일자",
    "processing_con": "처리내용",
    "combcombination_id": "번호",
    "combcombination_num": "묶음수량",
    "origin": "출발지",
    "trk_cnt": "운송장 수",
    "pro_info_msg": "상품정보 (취소 신청할 상품 선택 가능)",
    "pro_info": "상품정보",
    "cn_fee": "현지배송비",
    "shop_order_total_num": "총 오더번호 수",
    "reason_title": "신청 사유 (단일 선택)",
    "select_reson_msg": "신청 사유를 선택하세요",
    "detail_memo": "상세 사유",
    "detail_memo_init": "주문 취소 사유를 상세히 설명해주세요",
    "select_no_pro": "최소 하나의 상품을 선택하세요",
    "auto_select_charge": "관련 옵션이 자동으로 선택되었습니다.",
    "express": "택배",
    "yes": "예",
    "no": "아니요",
    "truck_inbound": "용달 입고 여부",
    "truck": "용달",
    "truck_info": "용달 정보",
    "look_trk_no_title": "트래킹번호 확인",
    "express_msg": "상품 정보에 트래킹번호를 입력하세요",
    "vehicle_information": "차량 번호",
    "driver_telphone": "기사 연락처",
    "pallet_number": "팔레트 수량",
    "box_number": "박스 수량",
    "arrived_time": "도착 예정일",
    "kr_recipient_msg": "한국 3PL 중국 구매대행 신청 시, 차이나원 한국 센터 주소가 기본 입력됩니다.",
    "truck_storage_number": "입고증번호",
    "slect_time": "시간선택",
    "express_package": "택배건",
    "stock_products": "재고상품",
    "stock_products_no": "일반상품",
    "stock_products_split": "재고 분할 상품",
    "prepay_amount": "선결제 금액",
    "return_products": "회송상품",
    "return_from_coupang_method": "처리방식",
    "return_order": "회송주문",
    "coupang_inbound_code": "쿠팡입고ID",
    "carriage_forward": "착불비용"
  },
  "allPackItemways": {
    "express_pack": "폴리백",
    "box_pack": "박스",
    "original_pack": "원포장"
  },
  "cancel_reasons": {
    "spec_error": "규격/옵션 선택 오류",
    "duplicate_order": "중복 주문",
    "wrong_address": "잘못된 배송 정보",
    "info_mismatch": "상품 정보 불일치",
    "stock_issue": "재고/발송 오류",
    "no_longer_needed": "일시적으로 필요하지 않음",
    "budget_change": "예산 조정",
    "other": "기타 사유"
  },
  "common": {
    "createSuccess": "추가 성공",
    "noSelection": "선택 가능한 항목이 없습니다",
    "packagRequested": "잔여 상품을 개별 포장하시겠습니까",
    "confirm_msg_packing": "포장 정보를 확인하시겠습니까",
    "coupang_msg_select": "쿠팡 정보 선택",
    "coupang_save": "쿠팡 정보를 저장하시겠습니까?",
    "updateSuccess": "수정 성공",
    "select_no_pack": "포장할 상품을 선택하세요",
    "delMessage": "삭제하시겠습니까?",
    "confirmTitle": "시스템 알림",
    "status2": "확인 완료",
    "confirm_cancel_yn": "재고 상품 분할 후 복구할 수 없습니다. 분할하시겠습니까",
    "loading": "데이터 로딩 중...",
    "confirmMessage": "선택한 데이터를 처리하시겠습니까?",
    "success": "성공",
    "failed": "실패"
  },
  "goods_shelf": {
    "max_num": "최대값"
  },
  "age_yn": {
    "y": "14세이상표시",
    "n": "14세이상표시안함"
  },
  "payment_status": {
    "paid": "결제완료",
    "unpaid": "결제대기",
    "pending_deposit": "입금대기중",
    "coupon_title": "쿠폰"
  },
  "bill_status": {
    "paid": "결제완료",
    "unpaid": "결제대기",
    "cancelled": "취소",
    "pending": "확인대기",
    "refunded": "전액환불"
  },
  "confirm": {
    "ignore_error": "해당 상품을 오류무시로 표시하시겠습니까?",
    "apply_ancellation": "해당 상품을 폐기 신청하시겠습니까?",
    "cancel_action": "이 작업을 취소하시겠습니까?",
    "cancelOutbound": "출고취소를 하시겠습니까?",
    "alert_title": "알림",
    "mark_as_read": "선택한 메시지를 읽음으로 표시하시겠습니까?",
    "logout_confirm": "정말 회원 탈퇴를 진행하시겠습니까?",
    "logout_description": "회원 탈퇴 시 현재 계정 및 관련 회원 정보가 삭제되며, 복구할 수 없습니다. 탈퇴 후 기존 계정으로 다시 로그인할 수 없으며, 회원 재가입도 불가능합니다. 진행 중인 주문, 환불, 예치금 및 기타 관련 업무가 모두 처리되었는지 확인한 후 탈퇴해 주세요.",
    "logout_warning": "탈퇴 처리는 취소하거나 되돌릴 수 없으므로 신중하게 진행해 주세요.",
    "logout_confirm_button": "회원 탈퇴",
    "edit_confirm": "수정하시겠습니까?",
    "delete_address": "주소를 삭제하시겠습니까?",
    "delete_trk": "삭제하시겠습니까?",
    "application_for_return": "원송장반품을 신청하시겠습니까?",
    "delete_note": "선택한 메시지를 삭제하시겠습니까?",
    "submit_order": "제출 신청하시겠습니까?",
    "submit_selected_order": "해당 주문을 제출하시겠습니까?",
    "copy_product": "해당 상품을 복사하시겠습니까?",
    "delete_product": "해당 상품을 삭제하시겠습니까?",
    "sync_register_title": "등록 상품 동기화",
    "sync_register_message": "이번 주문에 기본 상품이 사용되었습니다. 등록 상품으로 동기화하시겠습니까?",
    "sync_register_hint": "동기화하면 해당 상품을 \"등록 상품\"에서 계속 사용할 수 있습니다.",
    "sync_register_only": "주문만 하기",
    "sync_register_and_order": "동기화 후 주문",
    "sync_register_failed": "상품 동기화 등록에 실패했습니다. 상품 관리에서 직접 등록해 주세요.",
    "sync_register_success": "상품 동기화 등록이 완료되었습니다. 상품 관리에서 확인할 수 있습니다.",
    "sync_register_failed_alert": "상품 동기화 등록에 실패했습니다. 주문은 정상적으로 생성되었습니다. 확인을 누르면 주문 상세 페이지로 이동합니다.",
    "delete_stock_product": "선택한 재고 상품을 삭제하시겠습니까?",
    "delete_order": "해당 주문을 삭제하시겠습니까?",
    "delete_product_limit_tip": "더 이상 삭제할 수 없습니다. 최소 하나의 상품은 유지해야 합니다.",
    "save_product": "저장하시겠습니까?",
    "change_password": "비밀번호를 변경하시겠습니까?",
    "confirm_payment": "결제하시겠습니까?",
    "bank_transfer_title": "계좌이체 확인",
    "bank_transfer_amount_tip": "이번에 이체하실 금액입니다",
    "bank_transfer_notice": "확인 후 결제 내역이 생성됩니다. 화면에 표시된 입금 계좌로 이체해 주세요.",
    "select_payment_item_tip": "결제할 청구서를 선택하세요.",
    "split_order": "선택한 상품을 나눔하시겠습니까?",
    "bundle_order": "선택한 주문을 묶음하시겠습니까?",
    "delete_file": "선택한 파일을 삭제하시겠습니까?",
    "save_coupang_reservation": "쿠팡 입고 정보를 저장하시겠습니까?",
    "coupon_msg": "해당 비용에 쿠폰이 선택되어 있습니다. 변경하려면 먼저 취소하세요",
    "coupon_once": "해당 쿠폰은 이미 사용되었습니다",
    "coupon_amount_limit": "쿠폰 금액이 현재 결제금액을 초과하여 사용할 수 없습니다",
    "used_coupon": "사용 완료",
    "apply_cancel": "취소 신청하시겠습니까?",
    "order_list_none": "해당 비용에 주문 정보가 없습니다"
  },
  "coupang_center": "쿠팡 물류센터",
  "please_login_first": "서비스를 이용하려면 먼저 로그인해주세요.",
  "chinaone_login": "ID 로그인",
  "chinaone_sms_login": "인증번호 로그인",
  "input_userid": "아이디를 입력하세요",
  "input_password": "비밀번호를 입력하세요",
  "remember_userid": "아이디 기억하기",
  "login_button": "로그인",
  "register_button": "회원가입",
  "find_idpw": "ID/PW 찾기",
  "naver": "NAVER",
  "naver_preparing": "준비중",
  "login_with_account": "계정으로 로그인",
  "userid": {
    "check_memid": "중복 확인",
    "required": "아이디를 입력하세요",
    "exists": "해당 아이디는 이미 사용 중입니다",
    "available": "사용 가능한 아이디입니다"
  },
  "password": {
    "required": "비밀번호를 입력하세요"
  },
  "password_confirm": {
    "required": "비밀번호를 확인하세요",
    "msg": "입력한 비밀번호가 일치하지 않습니다."
  },
  "name_ko": {
    "required": "이름(한글)을 입력하세요"
  },
  "name_en": {
    "required": "이름(영문)을 입력하세요"
  },
  "mobile": {
    "required": "휴대폰 번호를 입력하세요",
    "placeholder": "휴대폰 번호를 입력하세요 ('-' 제외)",
    "delivery_placeholder": "휴대폰 번호",
    "required_return": "연락처를 입력하세요",
    "msg": "유효한 휴대폰 번호를 입력하세요"
  },
  "email": {
    "required": "이메일 주소를 입력하세요",
    "msg": "유효한 이메일 주소를 입력하세요"
  },
  "code": {
    "sms": "휴대폰 번호를 입력하세요",
    "email": "이메일 주소를 입력하세요",
    "msg": "인증번호가 발송되었습니다"
  },
  "business_address": {
    "title": "사업자등록증 주소",
    "required": "사업자등록증 주소를 입력하세요."
  },
  "barcode_label_info": {
    "title": "바코드 번호 상세"
  },
  "barcode_info": {
    "title": "바코드 정보",
    "platform_select_title": "플랫폼 상품 정보 선택",
    "selectPlatform": "플랫폼을 선택하세요",
    "platformProductInfo": "플랫폼 상품 정보"
  },
  "certificate_of_origin": {
    "title": "원산지 증명서(C/O)용",
    "product_name_en": "상품 영문명",
    "hs_code": "HS 코드"
  },
  "customs_item": {
    "required": "통관 품목을 선택하세요"
  },
  "rocket_address_warning": {
    "title": "- 로켓주문 신청 시, 수취인 주소는 수정할 수 없습니다."
  },
  "reset_password": "비밀번호 찾기",
  "register_form": {
    "notification_consent": {
      "title": "정보 수신 및 이용 동의",
      "kakao": "카카오 알림톡 수신 동의",
      "sms": "SMS 수신 동의",
      "email": "이메일 수신 동의"
    },
    "registration_steps": "회원가입 단계",
    "terms_step": "약관 동의",
    "agree_all": "전체 동의",
    "details_step": "회원정보 입력",
    "terms_required_hint": "위의 필수 약관 두 항목을 읽고 동의한 후 진행해 주세요.",
    "validation_failed": "회원가입 정보를 확인하고 빠짐없이 입력해 주세요.",
    "next_step": "다음 단계",
    "previous_step": "이전 단계",
    "previous_step_confirmation": "이전 단계로 돌아가면 현재 입력한 모든 가입 정보가 삭제됩니다. 계속하시겠습니까?",
    "login_type_sms": "휴대폰 인증 로그인",
    "login_type_user": "아이디 비밀번호 로그인",
    "userid": "아이디",
    "userid_rule": "영문과 숫자 조합만 사용할 수 있습니다.",
    "password": "비밀번호",
    "password_rule": "비밀번호는 최소 6자 이상이어야 합니다.",
    "password_confirm": "비밀번호 확인",
    "show_password": "비밀번호 표시",
    "hide_password": "비밀번호 숨기기",
    "name_ko": "이름(한글)",
    "name_en_required": "이름(영문)",
    "mobile": "휴대폰 번호",
    "mobile_kr_cn": "한국 또는 중국 휴대폰 번호",
    "verification_code": "인증번호",
    "get_verification_code": "인증번호 받기",
    "verification_code_required": "휴대폰 인증번호를 입력하세요",
    "verification_code_not_sent": "먼저 휴대폰 인증번호를 받아 주세요",
    "verification_code_incorrect": "휴대폰 인증번호가 올바르지 않습니다",
    "mobile_changed_after_code": "휴대폰 번호가 변경되었습니다. 인증번호를 다시 받아 주세요",
    "mobile_verification_required": "휴대폰 번호 인증을 완료해 주세요",
    "email": "이메일 주소",
    "email_login_tip": "※ 정확한 이메일 주소를 입력해 주세요. 동일한 이메일로 네이버·카카오 간편 로그인이 가능합니다.",
    "referrer_id": "추천인 아이디",
    "referrer_code": "추천인 코드",
    "referrer_code_tip": "선택 입력 항목입니다. 추천인 코드가 있으면 입력해 주세요. 없으면 비워 두셔도 됩니다.",
    "deposit_personal_krw": "개인 - 원화 예치금",
    "deposit_personal_cny": "개인 - 위안화 예치금",
    "deposit_business_krw": "사업자 - 원화 예치금",
    "deposit_business_cny": "사업자 - 위안화 예치금",
    "user_type": {
      "title": "개인/사업자",
      "placeholder": "사용자 유형을 선택하세요",
      "personal": "개인",
      "business": "사업자"
    },
    "deposit_type": {
      "title": "예치금 신청 유형",
      "placeholder": "예치금 신청 유형을 선택하세요",
      "krw": "원화 예치금 신청",
      "cny": "위안화 예치금 신청"
    },
    "kr_business_info": "한국 사업자정보",
    "cn_business_info": "중국 사업자등록 정보 (사업자 계정이 위안화 신청을 선택할 경우, 중국 사업자 정보를 입력해야 합니다)",
    "business_phone": {
      "title": "연락처",
      "placeholder": "연락처를 입력하세요"
    },
    "business_address": {
      "title": "사업자등록 주소",
      "placeholder": "사업자등록 주소를 입력하세요"
    },
    "business_license": {
      "title": "사업자등록증 파일"
    },
    "upload_license": "사업자등록증 업로드",
    "upload_tip": "첨부파일 업로드 크기: 1MB",
    "upload_size_limit": "파일 크기는 1MB를 초과할 수 없습니다",
    "upload_success": "업로드 성공",
    "cn_business_no": {
      "title": "중국 사업자등록번호",
      "placeholder": "중국 사업자등록번호를 입력하세요"
    },
    "cn_business_name": {
      "title": "중국 사업자명",
      "placeholder": "중국 사업자명을 입력하세요",
      "user_title": "중국 사업자 정보"
    },
    "cn_business_email": {
      "title": "중국 이메일",
      "placeholder": "중국 사업자 이메일을 입력하세요"
    },
    "sms_agreement": {
      "title": "SMS/카카오 알림 수신 동의(필수)",
      "info": "상태 정보를 지속적으로 받을 수 있습니다(견적, 입고, 출고, 배송, 오류 등)"
    },
    "business_no_kr": "한국 사업자등록번호",
    "business_no": {
      "title": "한국 사업자등록번호",
      "placeholder": "한국 사업자등록번호를 입력하세요 ('-' 제외)",
      "required": "한국 사업자등록번호를 입력하세요",
      "mypage": "사업자등록번호"
    },
    "business_ctms_no": {
      "title": "사업자 통관번호 (선택)",
      "placeholder": "사업자 통관번호를 입력하세요",
      "tip": "사업자 통관번호가 없거나 신청 방법을 모르시는 경우, 가입 후 고객센터에 신청 방법을 문의하시고 주문 통관에 지장이 없도록 신속히 입력해 주세요."
    },
    "business_name": {
      "title": "한국 사업자명",
      "placeholder": "한국 사업자명을 입력하세요",
      "required": "한국 사업자등록번호를 입력하세요",
      "mypage": "사업자명",
      "overdraft_limit": "보증금액",
      "user_title": "한국 사업자 정보",
      "country_kr": "한국어",
      "country_en": "영문"
    },
    "business_name_en": {
      "title": "영문 사업자명"
    },
    "legal_representative": {
      "title": "대표자",
      "placeholder": "대표자를 입력하세요",
      "required": "대표자를 입력하세요"
    },
    "business_file": {
      "title": "사업자등록증 파일"
    },
    "business_email": {
      "title": "회사 이메일",
      "placeholder": "이메일을 입력하세요",
      "required": "예치금 신청에 사용됩니다"
    },
    "business_file_kr": "한국 사업자등록증 파일",
    "select_image": "이미지 선택",
    "tax_invoice": {
      "title": "세금계산서 발급 여부",
      "N": "세금계산서 미발급",
      "Y": "세금계산서 발급",
      "Ntext": "세금계산서 미발급",
      "Ytext": "세금계산서 발급"
    },
    "terms_of_service": "서비스 이용약관",
    "required": "(필수)",
    "privacy_policy": "개인정보 수집 및 이용 안내",
    "submit_join": "가입"
  },
  "find_password": {
    "description": "가입하신 휴대전화 번호 또는 이메일을 입력해 주세요.",
    "code_validity": "인증번호는 유효시간 내에만 사용할 수 있습니다.",
    "verification_code_incorrect": "인증번호가 올바르지 않거나 만료되었습니다. 다시 입력해 주세요.",
    "get_code_first": "먼저 문자 인증번호를 받아 주세요",
    "user_not_found": "사용자를 찾을 수 없습니다. 휴대전화 번호 또는 이메일을 확인해 주세요.",
    "reset_confirm": "비밀번호를 재설정하시겠습니까?",
    "reset_success": "비밀번호가 설정되었습니다. 다시 로그인해 주세요.",
    "placeholders": {
      "sms": "등록된 전화번호를 입력하세요",
      "email": "등록된 이메일을 입력하세요",
      "code": "인증번호를 입력하세요",
      "new_password": "새 비밀번호를 입력하세요",
      "confirm_password": "새 비밀번호를 다시 입력하세요"
    },
    "button": {
      "submit": "인증"
    }
  },
  "file": {
    "delete_button": "파일 삭제",
    "upload_limit_msg": "파일당 최대 크기 제한",
    "coupang_file_required": "쿠팡파일을 모두 업로드해 주세요",
    "select_file_button": "파일 선택",
    "no_file_selected": "선택된 파일이 없습니다.",
    "file_type_f": "물류부착문서(PDF)",
    "file_type_t": "물류동봉문서(PDF)"
  },
  "email_template": {
    "title": "이메일 인증번호",
    "hello": "안녕하세요!",
    "verify_request": "페이지에서 다음 인증번호를 입력하여 인증을 완료하세요.",
    "code_expire": "이 인증번호는 :minutes 분 후에 만료됩니다.",
    "ignore_tips": "본인이 요청하지 않은 경우 이 이메일을 무시하세요.",
    "contact_tips": "문의사항이 있으시면 아래 이메일로 연락주세요."
  },
  "quick_btn": {
    "delivery": "배송대행 신청",
    "buy": "구매대행 신청",
    "excel": "엑셀 일괄 주문",
    "stock": "재고 관리 신청",
    "3pl": "물류 (3PL) 서비스",
    "shop": "상품 관리",
    "shop_desc": "상품 정보를 등록·관리합니다",
    "stock_desc": "재고 현황을 실시간으로 확인합니다",
    "shipping_desc": "출고 신청 및 배송을 조회합니다",
    "orders_desc": "전체 주문 내역을 확인합니다",
    "mnu1": "중국배송조회",
    "mnu2": "배송비용 안내",
    "mnu3": "비용 계산기",
    "mnu4": "한국배송조회",
    "mnu5": "출항스케줄",
    "mnu6": "통관 조회",
    "mnu7": "개인통관고유부호 신청",
    "mnu8": "노데이타 처리방법"
  },
  "nodata_list": {
    "title": "노데이타",
    "korea_title": "한국 노데이타",
    "china_title": "중국 노데이타",
    "empty_hint": "현재 창고 관련 데이터가 없습니다",
    "trk_tit": "트래킹번호",
    "owner_type": "택배 유형",
    "excel": "엑셀 일괄 주문",
    "stock": "재고 관리 신청",
    "3pl": "3PL 서비스",
    "shop": "상품 관리",
    "msg": "미결제 주문이 없습니다.",
    "addr": "등록된 배송지가 없습니다.",
    "search_addr": "검색 결과가 없습니다",
    "reg_product": "등록된 상품이 없습니다",
    "empty": "관련 데이터가 없습니다"
  },
  "email_rcv_yn": {
    "title": "이메일 수신"
  },
  "sms_rcv_yn": {
    "title": "SMS 수신"
  },
  "kakao_rcv_yn": {
    "title": "카카오 수신"
  },
  "error_msg": {
    "re_log": "권한이 없습니다. 다시 로그인해주세요.",
    "server": "서버에 연결할 수 없습니다.",
    "req": "요청 실패.",
    "select_product": "반품할 상품을 선택하세요. 오류입고 상품만 선택할 수 있습니다. 정상 상품을 반품하려면 관리자에게 문의하세요.",
    "ignore_error": "폐기할 상품을 선택하세요.",
    "personCtmsNo_required": "통과 번호를 입력하세요.",
    "businessNo_required": "사업자 번호를 입력하세요.",
    "duplicate_sku": "이미 존재합니다. 중복 추가할 수 없습니다"
  },
  "delivery_title": {
    "delivery": "배송대행",
    "buy": "구매대행",
    "msg": "※ 로켓그로스 한국센터 서비스 이용료는 예치금 자동결제로 처리되며, 보유 예치금 20만원 이상이어야 이용 가능합니다."
  },
  "loading": {
    "search": "검색 중..."
  },
  "way": {
    "title": "입금마감 시간안내",
    "ship": "해운",
    "plane": "항공",
    "lcl": "LCL"
  },
  "kakao": {
    "title": "카카오톡 실시간 상담",
    "kakao_rcv_yn": "카카오"
  },
  "date": {
    "title": "일정",
    "mon": "월",
    "tue": "화",
    "wed": "수",
    "thu": "목",
    "fri": "금",
    "sat": "토",
    "sun": "일"
  },
  "mny": {
    "title": "환율 정보",
    "exg_rt": "구매대행 환율",
    "appl_exg_rt": "고시 환율",
    "tt": "TT 송금 환율",
    "sbj": "적용 기간"
  },
  "bank_column": {
    "title": "계좌안내",
    "acc_holder": "예금주",
    "msg1": "주문자와 입금자 이름이 다른경우 확인이 어렵습니다.",
    "msg2": "주문건과 입금자명 확인 후 입금부탁드립니다.",
    "sbj": "적용 기간"
  },
  "customer_center": "고객센터",
  "recommended_cn_shop": "중국 쇼핑몰 추천",
  "footer": {
    "terms_of_use": "이용약관",
    "privacy_policy": "개인정보처리방침",
    "site_map": "사이트맵",
    "email": "이메일",
    "address_kr": "사업장주소: 인천광역시 서해구 북항로177번길 96 C동",
    "address_cn": "통신판매신고번호: 2024-인천서구-2921호 ㅣ 개인정보책임자 : 이철홍",
    "business_number": "사업자등록번호",
    "partnership": "제휴 문의"
  },
  "top_banner": {
    "promo": "업계 최초 구매대행 수수료 0%",
    "promo_prefix": "업계 최초 · 구매대행 수수료",
    "msg": "다른 배송 센터의 월 출하 수량이 50개 이상이면 '프리미엄 회원'으로 승급됩니다.",
    "solution": "배대지 NO1 솔루션 · 솔루션 파트너 신청",
    "solution_prefix": "배대지 ",
    "solution_highlight": "NO1",
    "solution_suffix": " 솔루션 · 솔루션 파트너 신청"
  },
  "feedback": {
    "category_placeholder": "선택하세요",
    "entry_title": "오류 신고 & 개선 제안",
    "submit_prefix": "제출: ",
    "title": "제목",
    "title_placeholder": "제목을 입력해 주세요 (최대 100자)",
    "content": "내용",
    "content_placeholder": "문제 또는 개선 의견을 자세히 입력해 주세요...",
    "attachments": "이미지 첨부 (선택)",
    "upload_image": "이미지 업로드",
    "upload_tip": "JPG, PNG, GIF, WEBP 이미지 형식, 파일당 최대 10MB, 최대 9장",
    "submit": "제출",
    "title_required": "제목을 입력해 주세요",
    "title_limit": "제목은 100자를 초과할 수 없습니다",
    "content_required": "내용을 입력해 주세요",
    "content_limit": "내용은 2000자를 초과할 수 없습니다",
    "image_only": "이미지 파일만 업로드할 수 있습니다",
    "image_size_limit": "이미지는 한 장당 10MB를 초과할 수 없습니다",
    "image_count_limit": "이미지는 최대 9장까지 업로드할 수 있습니다",
    "uploading": "첨부 파일을 업로드 중입니다. 잠시만 기다려 주세요",
    "upload_failed": "이미지 업로드에 실패했습니다. 다시 시도해 주세요",
    "submit_failed": "제출에 실패했습니다. 다시 시도해 주세요",
    "success_title": "제출 완료",
    "success_message": "최대한 빠르게 확인하겠습니다. ‘내 피드백’에서 처리 현황을 확인할 수 있습니다. 소중한 의견 감사합니다!",
    "list": {
      "entry": "내 피드백 보기",
      "title": "내 피드백",
      "description": "제출한 오류 신고, 개선 제안 및 처리 현황을 확인할 수 있습니다",
      "title_search": "제목을 입력해 주세요",
      "type": "유형",
      "status": "상태",
      "all": "전체",
      "id": "ID",
      "submitted_at": "제출 일시",
      "actions": "작업",
      "view": "보기",
      "error_report": "오류 신고",
      "improvement_proposal": "개선 제안",
      "pending_reply": "답변 대기",
      "processing": "처리 중",
      "replied": "답변 완료",
      "total": "총 {total}건",
      "detail_title": "피드백 상세",
      "reply_history": "답변 내역",
      "no_reply": "아직 답변이 없습니다",
      "customer_service": "고객센터",
      "load_failed": "피드백 목록을 불러오지 못했습니다",
      "detail_failed": "피드백 상세 내용을 불러오지 못했습니다",
      "delete_confirm": "피드백 “{title}”을(를) 삭제하시겠습니까?",
      "delete_success": "삭제되었습니다",
      "delete_failed": "삭제에 실패했습니다"
    },
    "categories": {
      "functional_error": "기능 오류",
      "display_error": "화면 표시 오류",
      "order_problem": "주문 처리 문제",
      "payment_refund_problem": "결제 및 환불 문제",
      "data_error": "데이터 오류",
      "functional_improvement": "기능 개선 제안",
      "new_feature": "신규 기능 제안",
      "usability_improvement": "사용 편의성 개선",
      "other": "기타 문의"
    }
  },
  "select": {
    "placeholder": "선택",
    "language_kr": "한국어",
    "language_zh": "중국어",
    "delivery_method": "운송방식",
    "application_type": "신청구분",
    "order_status": "= 주문상태",
    "shipment_type": "= 출고방법",
    "customs_item": "= 통관 품목을 선택하세요",
    "payment_status": "결제 상태",
    "payment_number": "결제 번호",
    "order_number": "주문번호",
    "service_type": "서비스 유형",
    "bill_number": "청구서 번호",
    "refund_bill_number": "환불 청구서",
    "bill_type": "청구서 유형"
  },
  "datepicker": {
    "start": "시작",
    "end": "종료",
    "last_week": "최근 1주",
    "last_month": "최근 1개월",
    "last_3_months": "최근 3개월"
  },
  "buyPreOrders": {
    "title": "구매대행 주문번호"
  },
  "changeOrders": {
    "title": "이전 주문번호"
  },
  "frmSearch": {
    "sOrderNo": "주문번호",
    "sOrderType": "주문유형",
    "sTrkNo": "트래킹번호",
    "sConsNmKr": "수취인",
    "sProNm": "상품명",
    "sProNo": "상품번호",
    "sIvcNo": "운송장번호",
    "STOCK_NO": "재고번호",
    "sMarketBarCode": "상품 바코드 번호",
    "sMarketOptionId": "상품 옵션 ID",
    "sChargeDetCd": "= 세금계산서 유형",
    "sIssueDvsCd": "= 세금계산서 구분",
    "payCost": "결제 비용",
    "deposit_Use": "예치금 사용",
    "USE_POINT": "쿠폰 사용",
    "SEND_CENTER_NM": "발송 센터",
    "QTY_COST": "총 수량/금액",
    "UP_DATE": "일자",
    "DLVR_WAY_SEND_CENTER_NM": "센터/운송 방식",
    "TRK_WARE_CNT": "트래킹 수/입고 수",
    "yesterday_storage_fee": "전일 보관료(₩)",
    "in_date": "입고 일자",
    "out_date": "출고 일자",
    "single_wt": "무게 KG",
    "single_size": "포장규격",
    "single_vol": "부피 CBM",
    "totle_vol": "총 부피",
    "product_type": "상품 유형",
    "rack_nos": "랙번호",
    "in_out_details": "입고/출고 상세",
    "in_details_title": "입고 상세",
    "out_details_title": "출고 상세"
  },
  "rocket": {
    "header": "로켓그로스 물류센터 정보"
  },
  "header_menu": {
    "china_purchased": "중국구매",
    "kr_warehouse_storage": "한국 센터 보관",
    "sea_air_dlv": "해운/항공",
    "coupang_warehouse": "쿠팡 창고",
    "stock_storage": "재고 보관",
    "delivery_truck": "택배/용달"
  },
  "info": {
    "dpst": "예치금",
    "nodata": "미확인",
    "unpay": "미결제",
    "note": "알림"
  },
  "request_type": {
    "direct_prchase": "해외직구",
    "express_pickup": "밀크런택배",
    "collection_pallet": "밀크런팔레트",
    "general_express_delivery": "일반택배",
    "rocket_official_cabinet": "쿠팡직배송",
    "kr": "한국 3PL",
    "cn": "중국 3PL",
    "kr_code": "한국",
    "cn_code": "중국",
    "kr_stock_out": "한국 재고 출고",
    "sample": "택배건"
  },
  "menu": {
    "direct_purchase": "해외직구",
    "ecommerce_order": "일반해운",
    "guide": "사용방법",
    "guide_order": "주문가이드",
    "pricing_info": "요금 안내",
    "freight_prediction": "예상 배송비",
    "delivery_service": "배송대행",
    "delivery_service_order": "배송대행 신청",
    "delivery_service_excel": "배송대행 일괄 신청",
    "delivery_service_desc_1": "전 세계 어디든 배송해드립니다",
    "delivery_service_desc_2": "다양한 배송 채널, 안전하고 효율적",
    "delivery_request": "배송 신청",
    "buying_service_order": "구매대행 신청",
    "ocean_logistics_order": "LCL / FCL",

    "buying_service_excel": "구매대행 일괄 신청",
    "bulk_excel_upload": "엑셀 일괄 업로드",
    "inventory_request": "재고 신청",
    "buying_service": "구매대행",
    "buying_service_desc_1": "전문 구매대행팀이 상품 구매를 도와드립니다",
    "buying_service_desc_2": "다양한 플랫폼 구매대행 지원",
    "buying_request": "구매신청",
    "product_management": "등록상품관리",
    "product_excel_upload": "상품일괄등록",
    "rocket_service": "로켓그로스대행",
    "rocket_delivery_request": "배송신청",
    "inbound_request": "입고신청",
    "rocket_buying_request": "구매신청",
    "customer_service": "고객센터",
    "notice": "공지사항",
    "notice_3pl": "3PL 공지",
    "faq": "자주묻는 질문",
    "user_reviews": "이용후기",
    "lost_and_found": "노데이타",
    "no_data": "노데이타 관리",
    "return_no_data": "회송 노데이타",
    "address_management": "배송지 관리",

    "customs_schedule": "통관 일정 조회",
    "my_page": "마이페이지",
    "member_info": "회원정보",
    "order_status": "주문 목록",
    "order_detail": "주문 상세",
    "payment_management": "결제 관리",
    "deposit_krw": "원화 예치금 신청",
    "deposit_cny": "위안화 예치금 신청",
    "coupon_list": "쿠폰 관리",
    "notification_messages": "알림 메시지",
    "edit_profile": "회원 정보",
    "product_main": "상품 관리",
    "order_main": "주문 관리",
    "china_inventory": "중국 재고",
    "china_inventory_upload": "배송대행 입고",
    "buy_cn_inventory": "구매대행 입고",
    "korea_inventory": "한국 재고",
    "korea_inventory_cn": "한국 재고 중국 수입",
    "buy_cn_delivery": "중국 구매 주문",
    "buy_kr_delivery": "국내 입고",

    "buy_cn": "중국 구매",
    "buy_kr": "한국 구매",
    "rocket_china": "중국",
    "rocket_korea": "한국",
    "inbound_kr": "한국 입고",
    "korea_inventory_shipping": "한국 재고 출고",
    "send_way": "택배/용달",
    "service_application": "서비스 신청",
    "point_management": "포인트 관리",
    "account_management": "계정 관리",
    "cn_3pl_inbound": "중국 3PL 입고",
    "kr_3pl_inbound": "한국 3PL 입고",
    "kr_3pl_outbound": "한국 3PL 출고",
    "cn_3pl_inbound_desc": "중국 창고에서 상품 집하",
    "kr_3pl_inbound_desc": "한국 창고로 상품 입고",
    "kr_3pl_outbound_desc": "한국 창고에서 구매자에게 발송",
    "buy_cn_inventory_desc": "구매대행 후 중국 창고 입고",
    "china_inventory_upload_desc": "직접 구매한 상품을 중국 창고로 발송",
    "inventory_dropshipping_kr": "재고 출고신청",
    "inventory_dropshipping_kr_order": "재고출고 신청",
    "inventory_dropshipping_kr_excel": "재고출고 대량신청",
    "inventory_batch_outbound": "재고 대량출고",
    "inventory_batch_outbound_order": "재고주문 대량신청",
    "inventory_batch_outbound_statistics": "재고출고 통계",
    "cooperation_management": "협업관리"
  },
  "coupon_yn": {
    "coupon_y": "사용 가능",
    "coupon_n": "사용 불가"
  },
  "stock_manage": {
    "registered_label": "가입",
    "today_fee_tip": "실시간 예상 금액입니다. 보관료 청구서는 매일 24시(자정)가 지나야 생성됩니다.",
    "expiry_managed": "소비기간 관리",
    "no_expiry": "소비기간 없음",
    "unit_item": "개",
    "unit_sku": "개",
    "unit_bill": "건",
    "fee_detail": "비용 내역",
    "no_unpaid": "미결제 없음",
    "select_all": "전체 선택",
    "selected": "{n}개 선택됨"
  },
  "combined_builder": {
    "delete_item_confirm": "이 세트에서 해당 상품 옵션을 삭제하시겠습니까?",
    "delete_package": "세트 삭제",
    "delete_selected": "선택 삭제 ({count})",
    "select_all": "세트 내 상품 전체 선택",
    "select_item": "상품 선택",
    "delete_selected_confirm": "{name}에서 선택한 옵션 {count}개를 삭제하시겠습니까?",
    "select_product_customs": "통관 코드를 선택해 주세요.",
    "fill_product_english_name": "「{name}」의 영문 상품명을 입력해 주세요.",
    "composition_count": "옵션 {count}종 / {quantity}개",
    "invalid_price": "상품 단가는 0보다 커야 합니다. 확인 후 추가해 주세요.",
    "delete_package_confirm": "{name} 및 포함된 모든 옵션을 삭제하시겠습니까?",
    "fill_required_fields": "모든 세트의 필수 정보를 입력해 주세요",
    "fetch_product": "상품 가져오기",
    "collapse": "접기",
    "expand": "펼치기",
    "added": "추가됨",
    "items_across_packages": "개 (전체 세트)",
    "customs_complete": "통관 정보 입력됨",
    "customs_pending": "통관 정보 입력 필요",
    "stock": "재고",
    "action": "작업",
    "out_of_stock": "품절",
    "added_to_current_package": "현재 세트에 추가됨",
    "add_to_prefix": "추가할 세트: ",
    "add_to_current_package": "현재 세트에 추가",
    "quantity_stock_hint": "수량이 0이면 1개로 추가됩니다. 빨간 숫자는 재고입니다.",
    "drag_or_add_hint": "왼쪽 옵션 행을 세트로 드래그하거나 추가 버튼을 누르세요",
    "drop_to_add": "놓으면 이 세트에 추가됩니다",
    "current_package": "선택된 세트",
    "click_to_select": "클릭하여 선택",
    "empty_package_hint": "왼쪽 상품 옵션을 여기로 드래그하거나 추가 버튼을 누르세요",
    "stock_limit_reached": "이 옵션의 재고 한도에 도달했습니다",
    "stock_limit": "재고 한도",
    "product_link": "상품 링크",
    "product_attributes": "상품 속성",
    "already_in_package": "이 옵션은 현재 세트에 이미 추가되었습니다",
    "product_already_fetched": "이미 가져온 상품입니다. 기존 상품에서 옵션을 선택해 주세요.",
    "fetch_product_failed": "상품 정보를 가져오지 못했습니다. 링크를 확인해 주세요.",
    "source_missing": "상품 출처 정보가 없습니다. 옵션을 다시 추가해 주세요.",
    "registration_success": "등록 완료",
    "registration_uncertain": "등록 결과를 확인할 수 없습니다. 상품 목록에서 등록 여부를 확인한 후 다시 시도해 주세요.",
    "batch_result": "{added}개 추가, {existing}개 중복, {outOfStock}개 품절로 제외 ({packageName})",
    "select_field": "{label}을(를) 선택해 주세요"
  },
  "pro_manage": {
    "edit_barcode_info": "바코드 수정",
    "edit_basic_info": "정보 수정",
    "simple_mode": "상품 보기",
    "view_mode": "보기 방식",
    "list_mode": "목록 보기",
    "grid_mode": "격자 보기",
    "option_details": "상품 옵션명 / 바코드ID / 옵션 ID",
    "package_details": "중량 / 포장 규격 / CBM",
    "created_label": "가입",
    "updated_label": "수정",
    "title": "바코드 상품명/상품번호/SKU번호/바코드 번호",
    "notice": "주의사항: 재고가 없는 상품만 삭제할 수 있습니다",
    "msg_del": "상품 또는 SKU를 먼저 선택하세요",
    "msg_confirm_del": "선택한 상품을 삭제하시겠습니까?",
    "msg_confirm_delist": "상품을 판매중지하시겠습니까?",
    "msg_confirm_restore": "상품을 판매재개 하시겠습니까?",
    "msg_delist": "판매 중지할 상품 또는 SKU를 먼저 선택하세요",
    "packing": "포장 규격",
    "combined_quantity": "묶음수량",
    "regi_modify_date": "등록/수정일",
    "single_add": "단일 상품 추가",
    "combine_add": "묶음 상품 추가",
    "single_product": "단일 상품",
    "combined_product": "묶음 상품",
    "sku_edit_title": "상품 SKU 정보 수정",
    "pro_edit_title": "구성 상품 정보 수정",
    "composition_title": "상품 구성 정보",
    "barcode_title": "바코드 정보",
    "barcode_number": "바코드 번호",
    "barcode_same_as_sku_tip": "플랫폼 상품 바코드 번호가 SKU CODE와 동일하면 수정할 수 없습니다. 다른 바코드를 입력해 주세요.",
    "product_registration": "상품 등록",
    "coupang_sku_code": "쿠팡",
    "same_platform_sku_id": "{platform}과 동일한 SKU ID",
    "coupang_sku_code_tip": "상품 등록 시 플랫폼 바코드 번호를 시스템 SKU Code로 동일하게 사용하면 라벨 부착 비용을 절감할 수 있습니다.",
    "sku_list": "SKU 목록",
    "exist_msg": "해당 SKU는 이미 추가되었습니다",
    "sku_none": "추가 가능한 SKU가 없습니다",
    "sku_end": "새로운 SKU가 추가되지 않았습니다",
    "sku_success": "추가 성공",
    "sku_add_msg": "먼저 SKU를 추가하세요",
    "market_pro_nm": "바코드 상품명",
    "no_sku_msg": "세트가 없습니다. 상품을 추가하세요.",
    "set_price": "세트 단가",
    "package": "세트",
    "sku_group_required": "{index}번째 SKU 그룹에 필수 정보가 누락되었습니다",
    "delete_success": "삭제 성공",
    "package_not_selected": "먼저 세트를 추가하세요",
    "new_package_created": "새로운 세트가 성공적으로 생성되었습니다",
    "packaging_request": "포장 작업 요청",
    "dlvry_warehouse": "배송 센터",
    "packing_title": "포장 정보",
    "inventory_details": "입고 내역",
    "out_details": "출고 내역",
    "stock_details": "재고 상세",
    "declaration_fee": "보관료",
    "down_stock_details": "재고 내역 다운로드",
    "all_confirm": "일괄 확인",
    "all_cancel": "일괄 취소",
    "delist_product": "사용중지",
    "all_delist_product": "전체 사용중지",
    "all_list_product": "전체 사용전환",

    "list_product": "사용중",
    "view_delisted_product": "사용중지 상품보기",
    "view_product_manage": "상품 관리 보기",
    "barcode_edit": "바코드 편집",
    "barcode_type": "바코드 유형",
    "same_or_different": "동종/이종",
    "same_kind": "동종",
    "different_kind": "이종",
    "duplicate_barcode_type_tip": "이미 선택한 바코드 유형입니다. 다른 유형을 선택해 주세요.",
    "barcode_upload_msg": "바코드 편집 이미지가 업로드되었습니다",
    "missing_coupang_barcode": "현재 쿠팡 바코드가 등록되지 않은 SKU가 있습니다. 등록상품 관리 페이지에서 쿠팡 바코드 정보를 입력한 후 다시 시도해 주세요."
  },
  "pro_manage_new": {
    "stat_total": "전체 상품",
    "stat_page_products": "현재 페이지 상품",
    "stat_page_options": "현재 페이지 옵션",
    "stat_spec_missing": "규격 미입력 (현재 페이지)",
    "unit_count": "개",
    "unit_option": "개 옵션",
    "col_product": "상품",
    "col_option": "옵션 / 바코드",
    "col_price": "단가",
    "col_weight": "중량",
    "col_qty": "묶음",
    "col_flags": "표시 항목",
    "col_status": "상태",
    "col_updated": "수정일",
    "flag_origin": "원산지",
    "flag_age": "14세↓",
    "flag_expiry": "소비기한",
    "option_count": "옵션 {n}개",
    "component_count": "구성 {n}개",
    "confirm_download": "상품 데이터를 엑셀로 다운로드하시겠습니까?",
    "selected": "{n}개 선택됨",
    "clear_selection": "선택 해제",
    "product_count": "{n}개 상품",
    "foot": "총 {total}개 · 페이지당 {size}개"
  },
  "excel": {
    "excel_sample": "대량등록 샘플다운",
    "excel_bulk_resgiter": "파일찾기",
    "bulk_res_download": "대량등록 엑셀 샘플다운",
    "customs_clearance_list_download": "통관 품목 목록 다운로드",
    "additional_service_download": "추가 서비스 다운로드",
    "logistics_center_download": "물류센터 목록 다운로드",
    "tips_msg": "일괄 등록 엑셀 샘플을 다운로드하여 작성 후 등록하세요.",
    "tips_co_title": "품목 최종 업데이트 일자",
    "tips_co_msg": "[C/O 발급 관련] 항목 추가",
    "file_search_button": "파일 선택",
    "file_size": "파일 최대 크기: 10 MB",
    "tips_center_msg": "예) 광주4(GWJ4) 물류센터 사용 시 코드 GWJ4를 입력하세요",
    "tips_reg_msg": "상품 대량등록 엑셀 샘플을 다운로드하여 작성 후 등록하세요.",
    "please_select_file": "엑셀 파일을 선택하세요",
    "email_result": "우편번호는 5자리입니다",
    "address_result": "주소는 도로명을 입력하세요",
    "submit_failed": "제출에 실패했습니다",
    "no_preview_data": "확인할 데이터가 없습니다",
    "no_valid_verification_data": "유효한 확인 데이터가 없습니다",
    "customs_code_verified": "개인통관고유부호 확인이 완료되었습니다",
    "verification_failed": "확인에 실패했습니다",
    "customs_code_verification_failed_title": "확인에 실패한 개인통관고유부호가 있습니다",
    "customs_item_number_required": "통관물품번호를 입력한 후 주문을 제출해 주세요."
  },
  "stock": {
    "logistics_Center": "물류센터 선택",
    "red_tips": "상품 정보 * 빨간 테두리는 필수 항목입니다",
    "no_data": "재고 상품이 없습니다."
  },
  "BUSI_DVS_CD": {
    "person": "개인",
    "Business": "사업자",
    "Foreigner": "VIP 회원"
  },
  "delivery_fee_rule": {
    "billing_value": "배송비 기준 중량/부피",
    "billing_range": "배송비 적용 범위",
    "starting_fee": "기본 요금",
    "billing_step": "요금 단위",
    "step_increment": "요금",
    "dimension_range": "세변합 범위",
    "weight_range": "중량 범위",
    "no_rule": "배송비 규칙이 없습니다",
    "more": "더보기"
  },
  "dlvr_calcuation": {
    "item_seq": "항목을 선택하세요",
    "total_mny": "상품 총금액을 입력하세요",
    "select_weight": "무게를 선택하세요",
    "title": "예상 배송비",
    "user_level": "회원등급",
    "dlvry_cd": "센터",
    "warehouse": "배송 센터",
    "transport_method": "운송 방식",
    "transport_type": "운송 유형",
    "item_title": "통관 코드 확인",
    "mny_title": "물품 총금액",
    "wt_title": "중량",
    "exg_title": "환율 변환",
    "service": "기타 추가 비용",
    "shipping": "운송비",
    "shipping_fee": "비용",
    "order_fee": "기타 추가 비용",
    "total_amout": "총금액",
    "purchase_cost": "구매 총비용",
    "purchase_mny": "구매비용",
    "apply_category": "신청구분",
    "purchase_fee": "구매 수수료",
    "pruchase_titme": "구매비용 측정시간",
    "cargo_information": "화물정보",
    "add_box_size": "박스 사이즈 추가",
    "box_size": "사이즈",
    "box_numbers": "박스 수량(개)",
    "rules_title": "운임 계산은 다음 과금 규칙을 기준으로 합니다",
    "rules_vol_ways": "부피 중량 계산 방법",
    "vol_ways_info": "물품 부피와 실제 무게 중 큰 값으로 과금하며, 부피 측정은 최고점 기준: 가로(cm) × 세로(cm) × 높이(cm) / 부피 계수 = 중량(kg)",
    "calculation_unit": "계산 단위",
    "calculation_kg": "중량 측정 시 0.5kg 단위로 올림합니다. 즉, 물품 중량이 5.35kg일 때 실제 과금은 5.5kg 기준입니다.",
    "calculation_cbm": "부피 측정 시 0.1CBM 단위로 올림합니다. 즉, 물품 부피가 1.12CBM일 때 실제 과금은 1.2CBM 기준입니다.",
    "calculation_charge_weight": "부피 중량",
    "calculation_real_weight": "실제 중량",
    "cancel_fee": "취소 수수료",
    "delivery_fee": "배송비용",
    "refund_fee": "환불비용",
    "return_fee": "반품비용",
    "discard_fee": "폐기비용",
    "calculator_title": "국제 물류 운임 계산기",
    "calculator_subtitle": "다양한 운송 방식의 물류 운임을 빠르게 계산합니다",
    "freight_tab": "운임 계산",
    "additional_tab": "부가 서비스",
    "basic_info": "기본 정보",
    "estimate_title": "비용 예상",
    "weight_label": "중량 (kg)",
    "weight_placeholder": "중량을 입력하세요",
    "weight_hint": "기본 {start}kg, 추가 {step}kg 단위로 계산",
    "volume_label": "부피 (CBM)",
    "volume_placeholder": "부피를 입력하세요",
    "volume_hint": "0.1CBM 단위로 계산됩니다",
    "box_count": "박스 수 (선택)",
    "box_placeholder": "미입력 시 부피÷0.1로 계산",
    "box_hint": "미입력 시 0.1CBM당 1박스로 계산됩니다",
    "pallet_count": "팔레트 수 (선택)",
    "pallet_placeholder": "미입력 시 부피÷1.8로 계산",
    "pallet_hint": "미입력 시 부피÷1.8을 올림하여 계산됩니다",
    "enter_measurement": "중량 또는 부피를 입력하면 계산됩니다",
    "no_matching_rule": "현재 회원등급에 해당하는 요금 규칙이 없습니다",
    "over_rule_range": "입력값이 현재 요금 규칙 범위를 초과했습니다",
    "select_grade_rule": "요금 규칙이 있는 회원등급을 선택하세요",
    "actual_weight": "중량",
    "freight_total": "운임",
    "first_weight_fee": "기본 중량 요금 ({value}kg)",
    "additional_weight_fee": "추가 중량 요금 ({count}×{step}kg)",
    "freight_subtotal": "운임 소계",
    "company_customs_fee": "사업자 통관 비용",
    "actual_volume": "실제 부피",
    "calculated_boxes": "계산 박스 수",
    "calculated_pallets": "팔레트 수",
    "box_unit": "박스",
    "pallet_unit": "팔레트",
    "billing_volume": "과금 부피",
    "volume_freight": "운임 ({count}×{step}CBM)",
    "document_fee": "B/L 차지비 + 핸드링차지비",
    "terminal_fee": "컨테이너작업비",
    "bonded_pickup_fee": "보세창고용달비",
    "korea_box_fee": "한국 비용 ({count}박스)",
    "bonded_pallet_fee": "보세창고용달비 ({count}팔레트)",
    "packing_fee": "포장 비용 ({count}팔레트)",
    "korea_pallet_fee": "한국 비용 ({count}팔레트)",
    "input_mode": "입력 모드",
    "simple_mode": "간편 모드",
    "simple_mode_hint": "전체 부피를 직접 입력",
    "detail_mode": "상세 모드",
    "detail_mode_hint": "상품 치수로 자동 계산",
    "auto_calculated": "자동 계산",
    "auto_volume_hint": "모든 상품의 치수와 수량을 기준으로 자동 계산됩니다",
    "product_list": "상품 목록",
    "optional": "(선택)",
    "product_list_hint": "바코드, 원산지 표시, 포장 등의 부가 서비스 비용 계산 시 상품을 추가하세요",
    "detail_product_list_hint": "상품 수량과 치수를 입력하면 부피와 부가 서비스 비용이 자동 계산됩니다",
    "empty_products": "상품이 없습니다. 부가 서비스 비용 계산 시 상품을 추가하세요",
    "empty_detail_products": "부피와 부가 서비스 비용을 계산하려면 상품을 추가하세요",
    "product_number": "상품 #{number}",
    "product_quantity": "상품 수량",
    "product_length": "가로 (cm)",
    "product_width": "세로 (cm)",
    "product_height": "높이 (cm)",
    "three_side_sum": "세 변의 합 (cm)",
    "size_fee_hint": "포장 및 OPP 봉투 비용 계산에 사용됩니다",
    "product_weight": "중량 (kg)",
    "barcode_service": "바코드 부착 (₩100/개)",
    "origin_label_service": "원산지 표시 작업",
    "origin_none": "필요 없음",
    "origin_sticker": "원산지 스티커 부착 (₩50/개)",
    "origin_tag": "원산지 택 부착 (₩200/개)",
    "origin_sewn": "원산지 라벨 봉제 (₩300/개)",
    "set_packaging": "세트 포장",
    "set_product_count": "세트 내 상품 수",
    "set_product_hint": "첫 상품은 정상가, 나머지는 80%",
    "opp_bag_service": "OPP 봉투 사용",
    "add_product": "상품 추가",
    "base_fee_total": "기본 운임 합계",
    "additional_fee_total": "부가 서비스 비용 합계",
    "barcode_fee": "바코드 부착 비용",
    "origin_label_fee": "원산지 표시 작업 비용",
    "set_packaging_fee": "세트 포장 비용",
    "opp_bag_fee": "OPP 봉투 비용",
    "estimate_notice": "위 금액은 참고용이며 실제 비용은 물류 서비스 업체의 견적을 기준으로 합니다",
    "tax_notice": "금액 단위는 원화(₩)입니다"
  },
  "ctms": {
    "placeholder": "올바른 품명을 선택하세요. (통관 신고용)"
  },
  "apply_wt_info": {
    "title": "무게정보"
  },
  "apply_wt": {
    "title": "적용무게"
  },
  "total_real_wt": {
    "title": "무게"
  },
  "conv_weight_kg": {
    "title": "부피 무게"
  },
  "CHARGE_WEIGHT": {
    "title": "부피"
  },
  "TOT_COST": {
    "title": "총 결제비용"
  },
  "MARK_NO": {
    "title": "마킹번호"
  },
  "PALLET_MARK_NO": {
    "title": "팔레트 마킹번호"
  },
  "IVC_ADD_INF": {
    "title": "경동택배"
  },
  "PACKING_ORDER_YN": {
    "title": "포장상태"
  },
  "WT_KG": {
    "title": "무게"
  },
  "VOL_WH": {
    "title": "가로"
  },
  "VOL_LH": {
    "title": "세로"
  },
  "VOL_HT": {
    "title": "높이"
  },
  "POST_NO": {
    "title": "사서함번호",
    "name": "회원이름"
  },
  "DPST": {
    "title": "예치금(￦)",
    "manage_title": "예치금 관리",
    "pay_title": "예치금 결제",
    "transfer_title": "무통장입금",
    "credit_card_title": "신용카드 결제"
  },
  "POINT": {
    "title": "포인트",
    "change_reason": "사용 구분",
    "point_amount": "포인트 변동",
    "point_principal": "사용 가능 포인트",
    "point_remark": "내용",
    "point_use_tip": "국제배송비용에만 사용 가능"
  },
  "COMPENSATION_DEPOSIT": {
    "title": "보상 예치금 관리",
    "short_title": "보상 예치금",
    "change_reason": "사용 구분",
    "change_amount": "보상 예치금 변동",
    "available_amount": "사용 가능 보상 예치금",
    "deduction": "보상 예치금 차감",
    "payment_placeholder": "보상 예치금 금액을 입력하세요",
    "use_all": "보상 예치금 전액 사용",
    "unsupported_bill": "선택한 청구서는 보상 예치금 결제를 지원하지 않습니다",
    "unsupported_order": "선택한 주문은 보상 예치금 결제를 지원하지 않습니다",
    "remark": "내용",
    "date": "날짜"
  },
  "payment_list_header": {
    "coupon_deduction": "쿠폰 차감",
    "point_deduction": "포인트 차감",
    "compensation_deduction": "보상 예치금 차감",
    "amount": "금액",
    "china_use": "(중국용)",
    "korea_use": "(한국용)"
  },
  "warehouse_popup": {
    "entry": "센터",
    "title": "배송대행지 주소",
    "copy_address": "주소 복사",
    "copy_full_address": "전체 주소 복사",
    "recipient_info": "수취인 정보",
    "member_code": "사서함번호",
    "postal_code": "우편번호",
    "province": "성",
    "city": "시",
    "phone": "연락처",
    "recipient": "수취인",
    "no_data": "사용 가능한 창고 정보가 없습니다",
    "copy_failed": "복사하지 못했습니다. 직접 복사해 주세요"
  },
  "coupon_qt": {
    "title": "쿠폰",
    "msg": "쿠폰을 사용하려면 예치금 자동 결제를 선택하세요.",
    "coupon_list": "쿠폰 목록",
    "already_used": "쿠폰이 이미 사용되었습니다.",
    "discount_amount": "쿠폰차감",
    "point_amount": "포인트차감"
  },
  "unpaid_qt": {
    "title": "미결제"
  },
  "icon": {
    "shopping": "구매대행",
    "truck": "배송대행",
    "logout": "입/출고",
    "truk1": "반품 관리",
    "error": "오류관리",
    "refresh": "재고 관리",
    "package": "로켓그로스",
    "stock": "재고"
  },
  "개": "개",
  "SUB_IVC_NO": {
    "title": "CJ대한통운"
  },
  "PAYMENT_WAY_CD": {
    "bank": "무통장 입금",
    "CreditCard": "신용카드",
    "title": "입금 계좌"
  },
  "tab_title": {
    "deposit_req": "예치금 신청",
    "compensation_deposit_management": "보상 예치금 관리",
    "payment settlement": "비용 결제",
    "paymentW": "미결제 청구서",
    "paymentWChina": "중국 미결제 청구서",
    "paymentWKorea": "한국 미결제 청구서",
    "paymentL": "결제완료 청구서",
    "DepositReq_1": "적립 신청",
    "DepositReq_2": "환불 신청",
    "DepositReq_3": "예치금 내역",
    "coupon": "사용 가능 쿠폰",
    "couponUsed": "쿠폰 사용 내역",
    "sms": "휴대폰 찾기",
    "email": "이메일로 찾기",
    "dialog": "새 비밀번호 설정",
    "phone": "전화번호",
    "code": "인증번호",
    "Order_Divide": "상품 목록",
    "Order_Bundle": "주문 목록"
  },
  "tips": {
    "msg1": "여러 항목을 한 번에 결제하려면 해당 항목을 모두 클릭하세요.",
    "msg2": "결제 대기 주문의 경우 모든 포장 및 운송비가 계산 완료되어 재포장 또는 합 배송, 단독배송이 불가능합니다.",
    "msg3": "※ 신용카드 결제 시 3.3% 수수료는 고객이 부담합니다.",
    "msg4": "KB국민은행 201301-04-460220 (이철홍(차이나원))",
    "msg5": "예치금 신청은 무통장 입금만 가능하며, 신청 후 1일 이내 확인 및 적립됩니다.",
    "msg6": "【중국 세금계산서】를 신청한 회원은 【원화 예치금 신청】을 신청할 수 없습니다.",
    "msg7": "*예치금 신청은 무통장 입금만 가능하며, 신청 후 1일 이내 확인 및 적립됩니다.",
    "msg8": "위안화 예치금 신청 후 입금하시면 원화로 환전해 드립니다. [위안화 입금액 × 환율 = 원화 예치금 금액]",
    "msg9": "아래 QR코드를 스캔하여 위안화 신청 금액을 송금하세요.",
    "msg10": "입금 시 반드시 이메일 번호를 입력해야 입금 확인이 가능합니다.",
    "msg11": "이메일 번호 입력 방법은 《이용안내 > 예치금 신청 안내》를 참조하세요.",
    "delMsg": "삭제할 알림 메시지를 선택하세요.",
    "markMsg": "알림 메시지를 선택하세요.",
    "SMS_RCV_YN": "알림 메시지: 상태 업데이트를 지속적으로 받을 수 있습니다(견적, 입고, 출고, 배송, 오류)",
    "perOrBus": "개인-원화 예치금 신청 (개인/사업자 전환 및 사업자 정보 변경은 카카오톡으로 신청하세요)",
    "LOGOUT_M1": "회원 탈퇴 후 첫 번째는 로그인할 수 없으며, 두 번째는 관리자가",
    "LOGOUT_M2": "확인 후 최종 탈퇴됩니다.",
    "LOGOUT_M3": "최종 탈퇴 후 등록된 개인정보는 삭제됩니다.",
    "LOGOUT_M4": "최종 탈퇴 전 관리자에게 문의하여 탈퇴를 취소할 수 있습니다.",
    "POST_NO_msg": "특수 문자가 허용되지 않는 곳은 #을 제거하고 등록하세요.",
    "COYP_SUCCESS": "복사 성공",
    "COPY_ERR": "복사 실패",
    "ADDR_MSG": "도로명을 입력하세요. 원활한 통관을 위해 올바른 도로명 주소를 사용하세요",
    "REQ_SEL": "국내 배송기사 분께 전달하고자 하는 요청사항을 남겨주세요(ex: 부재 시 휴대폰으로 연락주세요)",
    "ORDERS_MSG": "수령 신청할 주문을 선택하세요.",
    "COUPON_TIP": "추가 서비스 수정을 통해 쿠폰을 등록하세요.",
    "itemCont": "해당 주문에 상품이 1개뿐인 경우 주문만 삭제할 수 있습니다 (자식 송장번호만 남은 경우 삭제 불가)",
    "PRO_RES": "빨간 테두리는 필수 항목입니다",
    "TRK_CONT": "트래킹번호가 없는 경우 추후 '마이페이지'-'전체 주문'에서 입력하세요",
    "STOCK_CONT": "재고 상품 정보 변경 시 수량 외 정보는 재고 신청 상품 정보를 기준으로 합니다.",
    "item_seq": "통관 코드 검색",
    "PRO_NM_EN_CONT": "통관 지연을 방지하기 위해 정확히 입력하세요. (특수 문자 및 한글 입력 금지)",
    "PRO_AMT_CONT": "상품 총 결제 금액을 입력하세요.",
    "addr_det": "도로명을 입력하세요. 원활한 통관을 위해 올바른 도로명 주소를 사용하세요",
    "rokect_addr_det": "로켓 신청인 경우 받는 사람 주소는 chinaone 한국 창고 주소입니다.",
    "TOTAL_PRO_COST_M1": "세관 신고 금액 (쇼핑몰 결제 금액과 동일)",
    "TOTAL_PRO_COST_M2": "총금액이 미화 150달러 이상인 경우, 통관수수료가 부과됩니다.",
    "TOTAL_PRO_COST_M3": "목록통관이 불가한 식품,액체,식품,분말은 간이 통관으로 진행합니다(*세관 적발시 책임지지 않습니다.주의 하시기 바랍니다)",
    "ERR_TIPS": "접수신청을 하시게 되면 수정이 불가능합니다. 트래킹 번호 추가 등 수정이 필요하신 경우에는임시저장을 선택해주세요.",
    "ERR_TIPS_BR": "(신청 완료 후 특별한 사유로 요청서 수정이 필요한 경우 고객센터 1:1 문의 바랍니다)",
    "SELECT_TIPS": "차이나원에서는 합 배송, 단독배송 관련 없이 하나의 신청서로 배송신청이 모두 완료됩니다.",
    "CHECKBOX_TIPS": "주의사항을 모두 숙지하였으며, 위 약관에 동의합니다.",
    "CHECKBOX_TIPS_red": "필수",
    "ServerAgree": "서비스 신청 주의사항 약관에 동의해야 합니다.",
    "DLVR_WAY": "운송 방식을 선택하세요.",
    "tamall": "상품 주소를 입력하세요",
    "ctms_tips": "통관품목을 선택하세요",
    "Skus_tips": "상품 수량을 선택하세요",
    "Stock_tips": "수량을 입력하세요",
    "GetUrl_tips": "상품 URL을 입력하세요",
    "payment": "예치금은 결제 금액을 초과할 수 없습니다",
    "DIVIDE": "나눔 처리할 상품을 선택하세요.",
    "BUNDLE": "주문번호를 선택하세요.",
    "reg_del": "선택한 등록 상품을 삭제하시겠습니까?",
    "buy_tips": "구매견적을 신청 하신 후 견적이 완료되면 수정이 불가합니다.",
    "buy_tips_br": "(구매견적을 완료하신 후에 부득이한 사유로 요청서 수정이 필요한 경우에는 1:1문의를 주세요)",
    "return_payment_tip": "※ 국내창고 회송처리비용은 예치금 자동결제로만 가능하며, 보유 예치금 20만원 이상이어야 가능합니다.",
    "return_edit_tip": "(접수신청을 완료하신 후에 부득이한 사유로 요청서 수정이 필요한 경우에는 1:1문의를 주세요)",
    "WAREHOUSE_INVALID": "물류센터 정보가 유효하지 않습니다. 이전 단계로 돌아가 물류센터를 다시 선택한 후 주문해 주세요."
  },
  "placeholder": {
    "USE_DPST": "비용 결제",
    "USE_POINT": "포인트 사용",
    "PAYIN_NM": "입금자명",
    "LOGOUT": "현재 비밀번호를 입력하세요",
    "explame": "ex) 판교역로235,제주 첨단로 242",
    "TRK_NO": "트래킹번호 입력",
    "SHOP_ORDER_NO": "구매 주문번호 입력",
    "PRO_NM_EN": "상품 영문명",
    "pro_code": "상품 코드",
    "taobao_url": "상품 URL 입력"
  },
  "saveTrackingNumber": {
    "TRK_NO": "트래킹번호를 입력하세요."
  },
  "SubTrk": {
    "TRK_NO": "트래킹번호를 입력하세요."
  },
  "TRK_NO": {
    "msg": "트래킹번호를 입력하세요."
  },
  "dvCardFee": {
    "title": "신용카드 수수료"
  },
  "CouponMny": {
    "title": "쿠폰 할인",
    "coupon_use": "쿠폰 사용",
    "coupon_msg": "할인 후 결제 금액"
  },
  "frmDpstRet": {
    "MNY": "환불 금액"
  },
  "frmDpst": {
    "MNY": "위안화 예치금 신청 금액(￥)"
  },
  "ISSUEDVSCDObj": {
    "one": "회원 가입 이벤트",
    "three": "관리자 발급",
    "four": "회원 등급 쿠폰 발급"
  },
  "CHARGE_DET_CD_obj": {
    "one": "배송 비용",
    "nitythree": "처리 비용"
  },
  "Received": {
    "TITLE": "받은 쪽지"
  },
  "customs_company": {
    "company_select": "사업자 선택",
    "select_license": "사업자등록증 선택",
    "current_company": "현재 사업자 정보"
  },
  "formData": {
    "MEM_ID": "아이디",
    "POST_NO": "메일",
    "MEM_NM": "이름",
    "MEM_NM_EN": "영문명",
    "MOB_NO": "휴대폰 번호",
    "LASEST_LOG": "최종 로그인",
    "SMS_RCV_YN": "수신 동의(필수)",
    "person_Bus": "개인/사업자",
    "perOrBusMsg": "전환 및 사업자 정보 변경은 카카오톡으로 신청하세요.",
    "perOrBusTitle": "사업자 정보 수정 방법",
    "bus_info": "사업자 정보",
    "ChinaNum": "중국 사업자 번호",
    "ChianPartner": "중국 사업자명",
    "PERSON_CTMS_NO": "개인 통관 정보",
    "CONTACTS": "연락처",
    "DLVR_REQ_CONT": "배송 요청",
    "CENTER_REQ_CONT": "센터 요청"
  },
  "EIDT_PASSWORD": {
    "title": "비밀번호 수정",
    "oldpass": "기존 비밀번호를 입력하세요",
    "newpass": "새 비밀번호를 입력하세요",
    "newpass_cf": "새 비밀번호를 다시 입력하세요"
  },
  "newpass": {
    "required": "6~20자리 영문 대소문자, 숫자, 특수 문자로 등록하세요"
  },
  "newpass_cf": {
    "required": "새 비밀번호를 다시 입력하세요."
  },
  "oldpass": {
    "required": "기존 비밀번호를 입력하세요."
  },
  "PRO_AMT": {
    "required": "합계를 입력하세요 (최소 1 이상)"
  },
  "COLOR": {
    "required": "색상을 입력하세요."
  },
  "SIZE": {
    "required": "사이즈를 입력하세요."
  },
  "center_seq": {
    "qd": "칭다오",
    "kr": "한국 배송"
  },
  "Recipient": {
    "title": "수취인"
  },
  "return_msg": {
    "title": "반품"
  },
  "return_address_msg": {
    "title": "반품 주소"
  },
  "원": "원",
  "popup_title": {
    "addr": "배송지 목록",
    "addr_edit": "수취인 정보 수정",
    "shop_res": "상품 등록",
    "precautions": "주문 주의사항",
    "Logistics_sel": "배송지 선택",
    "vw_DLVR_WAY_CD_sel": "운송 방식 선택",
    "DLVR_WAY_TITLE": "센터 및 물류 방식",
    "pro_info_title": "상품 정보",
    "ZipSearch": "도로명 주소 검색",
    "shopping": "상품",
    "orderDivide": "나눔 배송",
    "DivideInfo": "현재 주문 정보",
    "COST": "비용 내역",
    "Order_Bundle": "묶음 배송",
    "TrkPhotoPop_S": "실제 이미지 보기",
    "PRE_PRO_NO": "구매 상품 번호",
    "RocketFile": "쿠팡 입고 정보 등록",
    "OrderPhotoPop": "출고실사",
    "stockTitle": "재고상품",
    "regpro_title": "등록상품 주문",
    "mny_title": "상품 금액 정보",
    "must": "는 필수 입력 항목입니다",
    "individual_pack": "잔여 상품 개별 포장",
    "combined_pack": "묶음포장",
    "storage_method_sel": "입고 방식 선택",
    "storage_method": "입고 방식",
    "outbound_method_sel": "출고 방식 선택",
    "outbound_method_tip": "주문의 출고 방식을 선택한 후 쿠팡입고 정보와 파일을 등록해 주세요.",
    "express_outbound_ready": "제출 후: 택배포장준비",
    "official_outbound_ready": "제출 후: 밀크런포장준비",
    "outbound_api_pending": "출고 신청 API가 아직 연결되지 않았습니다"
  },
  "origin_label": {
    "origin_no": "원산지 표시 없음",
    "origin_china": "원산지 표시 MADE IN CHINA"
  },
  "CONS_NM_KR": {
    "required": "한글 이름을 입력하세요.",
    "title": "수취인 정보",
    "placeholder": "한글 이름",
    "h5_title": "수취인 정보",
    "required_return": "수취인 이름을 입력하세요.",
    "company_name_kr": "사업자명(한글)",
    "company_name_en": "사업자명(영문)",
    "company_ctms_no": "사업자 통관 번호",
    "ctms_no": "통관번호"
  },
  "CONS_NM_EN": {
    "placeholder": "영문 이름"
  },
  "CTMS_DVS_CD": {
    "person": "개인통관고유부호",
    "bussiess": "사업자 번호",
    "passport": "여권 번호"
  },
  "CONS_ADDR": {
    "required": "주소를 입력하세요."
  },
  "CONS_ADDR_DET": {
    "required": "상세 주소를 입력하세요."
  },
  "CONS_ZIP": {
    "title": "주소",
    "title_EN": "주소(영문)",
    "title_DET": "상세 주소(한글)",
    "title_DET_EN": "상세 주소(영문)",
    "placeholder": "우편번호",
    "ckBASE_YN": "기본 배송지",
    "CONS_ADDR_DET": "상세 주소",
    "required": "우편번호를 입력하세요."
  },
  "WARE_RESERV_DT": {
    "title": "쿠팡 픽업일",
    "messages": "쿠팡 픽업일을 선택하세요.",
    "required": "쿠팡 픽업일은 오늘 이후여야 합니다."
  },
  "OUT_STATE_CD": {
    "title": "출고상태"
  },
  "PACKING_PRO_YN": {
    "title": "포장상태"
  },
  "MARKET_PRO_NM": {
    "title": "입고용 상품명",
    "placeholder": "마켓 상품명",
    "required": "마켓 상품명을 입력하세요."
  },
  "MARKET_BARCODE": {
    "title": "상품 바코드",
    "required": "상품 바코드를 입력하세요."
  },
  "MARKET_OPTION_NM": {
    "title": "상품 옵션명",
    "required": "입력하세요.",
    "option_name": "옵션명"
  },
  "MARKET_OPTION_ID": {
    "title": "상품 옵션 ID",
    "required": "상품 옵션ID를 입력하세요."
  },
  "MARKET_EXPIRY_DT": {
    "title": "소비기간",
    "y": "제품에 소비기간이 있음",
    "n": "제품에 소비기간이 없음",
    "required": "해당 상품은 소비기간이 설정되어 있습니다. 소비기간 날짜를 선택하세요"
  },
  "return_address": {
    "title": "반품 주소 정보",
    "h5_title": "(반품)수취인",
    "address": "(반품)주소",
    "title_3": "반품 주소 정보"
  },
  "ORIGIN_PRINT_YN": {
    "title": "원산지 표시"
  },
  "ORDER_NO_ORGIN": {
    "title": "이전 주문번호"
  },
  "ROCKET_COM_NM": {
    "title": "쿠팡 업체명",
    "required": "쿠팡 업체명을 입력하세요."
  },
  "ReInfo": {
    "title": "예약 정보"
  },
  "rokectH": {
    "title": "로켓그로스 물류 센터"
  },
  "WARE_RESERV_NO": {
    "title": "쿠팡 입고 요청 ID",
    "required": "쿠팡 입고 요청 ID를 입력하세요."
  },
  "PERSON_CTMS_NO": {
    "title": "개인통관고유부호 또는 사업자 번호 또는 여권 번호"
  },
  "req_sel": {
    "title": "배송 요청 선택",
    "placeholder": "= 선택하세요"
  },
  "DLVR_REQ_CONT": {
    "title": "배송 요청 직접 입력"
  },
  "DLVR_REQ_CONT_ELSE": {
    "title": "비고 정보"
  },
  "order_bundle": {
    "success_msg": "성공적으로 묶음 처리되었습니다.",
    "nodata_msg": "묶음 가능한 주문이 없습니다.",
    "bundle-tips": "묶음 처리할 주문을 선택하세요"
  },
  "OPTIONS": {
    "VALUE1": "배송 전 연락 바랍니다",
    "VALUE2": "부재 시 휴대폰으로 연락 바랍니다",
    "VALUE3": "부재 시 경비실에 맡겨주세요",
    "VALUE4": "부재 시 문 앞에 놔주세요",
    "VALUE5": "택배함에 맡겨주세요"
  },
  "orgin_options": {
    "single_label": "개별 원산지 라벨 부착",
    "set_label": "세트 원산지 라벨 부착",
    "tag_work": "원산지 태그 작업",
    "sewing_work": "원산지 봉제 작업",
    "stamp_work": "원산지 스탬프 작업"
  },
  "orgin_title": {
    "title": "원산지 라벨 작업 방식",
    "select": "선택",
    "write": "직접 입력",
    "origin_information": "C/O 발급용",
    "co_pro_en": "영문상품명"
  },
  "RocketFileTitle": {
    "title": "물류센터 첨부 파일"
  },
  "statusMap": {
    "order_state": "진행 상태",
    "dlv_state": "물류센터",
    "App_Category": "신청 구분",
    "PRO_STATE": "상품",
    "SVC_STATE": "자동결제",
    "MANUAL_SETTLEMENT": "수동결제"
  },
  "CONS_NM_INFO": {
    "TITLE": "수취인 정보"
  },
  "send_info": {
    "title": "발신자 정보"
  },
  "ROCKET_CONS_NM": {
    "TITLE": "수취인",
    "required": "물류센터 수취인 정보는 필수입니다"
  },
  "SHOP_INFO": {
    "TITLE": "상품 정보"
  },
  "AMT_INFO": {
    "TITLE": "금액 정보"
  },
  "ORDER_CHARGE": {
    "TITLE": "결제 정보",
    "TOTAL_MNY_TITLE": "총 비용",
    "charge_title": "청구 금액"
  },
  "BOX_CNT": {
    "TITLE": "박스 수"
  },
  "TRK_COUNT": {
    "TITLE": "트래킹 수"
  },
  "TOTAL_PRO_QTY": {
    "TITLE": "총 수량"
  },
  "TOTAL_PRO_COST": {
    "TITLE": "총 금액"
  },
  "Clearance": {
    "TITLE": "통관 구분"
  },
  "DLV": {
    "TITLE": "부가서비스"
  },
  "RES_COUPON": {
    "TITLE": "등록된 쿠폰"
  },
  "Logistics_REQ": {
    "TITLE": "물류센터 요청사항"
  },
  "Order_INQ": {
    "TITLE": "주문 문의"
  },
  "Management": {
    "TITLE": "관리"
  },
  "NOTE": {
    "제목입력": "제목 입력",
    "내용입력": "내용 입력"
  },
  "PAYIN_DT": {
    "required": "입금 일자를 선택하세요",
    "placeholder": "입금 일자"
  },
  "PAYIN_NM": {
    "required": "입금자명을 입력하세요"
  },
  "PAYIN_ACC_1": {
    "required": "은행명을 입력하세요"
  },
  "PAYIN_ACC_2": {
    "required": "환불금 수령 계좌번호"
  },
  "MNY": {
    "required": "금액을 입력하세요",
    "number": "금액을 올바르게 입력하세요",
    "max": "충전 금액은 100,000,000을 초과할 수 없습니다",
    "placeholder": "충전 금액",
    "name": "신청 금액"
  },
  "BANK_NM": {
    "title": "은행명",
    "required": "은행명을 입력하세요"
  },
  "ACC_NO": {
    "title": "계좌번호",
    "required": "환불금 수령 계좌번호"
  },
  "ACC_HOLDER": {
    "title": "예금주"
  },
  "coupon": {
    "un_used": "사용가능",
    "expired_coupon": "만료됨",
    "returned_coupon": "반환됨",
    "tip_msg": "사용 가능한 쿠폰이 없습니다.",
    "cancel_msg": "사용한 쿠폰을 취소하시겠습니까?",
    "coupon_name": "쿠폰명",
    "coupon_amount": "할인 금액",
    "coupon_grant_type": "발행 유형",
    "coupon_grant_kind": "발행 종류",
    "coupon_valid_date": "유효 기간",
    "long_term": "상시 유효"
  },
  "change_lang": {
    "text": "언어 변경 중..."
  },
  "site_map": {
    "title": "사이트맵",
    "subtitle": "필요한 서비스와 정보를 빠르게 찾아보세요",
    "home": "홈",
    "guide_list": "이용안내 목록",
    "account_access": "계정 바로가기",
    "guide_description": "처음 이용할 때 필요한 안내",
    "purchase_description": "온라인 주문과 빠른 배송",
    "lcl_description": "해상 운송 전문 서비스",
    "rocket_description": "중국·한국 입고 서비스",
    "three_pl_description": "창고 관리와 개별 배송",
    "service_description": "공지, 문의와 택배 서비스",
    "mypage_description": "주문, 결제와 계정 관리",
    "account_description": "로그인, 회원가입과 계정 찾기",
    "default_description": "서비스와 정보 바로가기"
  },
  "return_apply_process": {
    "apply_button": "신청처리",
    "dialog_title": "확인 처리",
    "process_method": "처리방식",
    "select_method": "처리방식을 선택해 주세요",
    "select_orders": "처리할 주문을 선택해 주세요",
    "complete_address": "수취인 정보를 모두 입력해 주세요",
    "unregistered_goods": "선택한 주문에 미등록 상품이 포함되어 있어 한국 재고 입고를 진행할 수 없습니다.",
    "success": "처리 신청이 완료되었습니다",
    "methods": {
      "1": "폐기",
      "2": "한국 재고 입고",
      "3": "한국 택배 출고",
      "4": "로켓그로스 일반택배",
      "5": "로켓그로스 밀크런택배",
      "6": "로켓그로스 밀크런팔레트"
    }
  },
  "return_from_coupang_method": {
    "1": "폐기",
    "2": "한국 재고 입고",
    "3": "한국 택배 출고",
    "4": "로켓그로스 일반택배",
    "5": "로켓그로스 밀크런택배",
    "6": "로켓그로스 밀크런팔레트",
    "7": "선택보류"
  },
  "return_from_coupang_type": {
    "title": "구분",
    "COUPANG_ERROR_RETURN": "회송",
    "COUPANG_CUSTOMER_OUTBOUND": "반출"
  },
  "outbound": {
    "电商快递": "일반해운",
    "海运物流": "LCL/FCL",
    "火箭官方快递揽收": "로켓그로스 밀크런택배",
    "火箭官方托盘揽收": "로켓그로스 밀크런팔레트",
    "火箭一般快递": "로켓그로스 일반택배",
    "火箭官方整柜入库": "쿠팡 직배송",
    "中国库存入库": "중국재고 입고",
    "韩国库存入库": "한국재고 입고",
    "韩国3PL一件代发": "3PL택배발송",
    "韩国快递出库": "한국택배출고",
    "中国仓库退货": "중국센터 반품",
    "韩国仓库退货": "한국센터 반품",
    "韩国返送": "한국 회송",

    "快递": "택배",
    "货车": "용달",
    "官方揽收快递": "밀크런택배",
    "官方揽收托盘": "밀크런팔레트",
    "官方整柜入库": "쿠팡 직배송"
  },
  "field": {
    "sms_no": "SMS 발송 안함",
    "sms_yes": "SMS 발송"
  },
  "defaultStatus": {
    "expectedInbound": "입고예정",
    "partialInbound": "부분입고",
    "inboundComplete": "입고완료",
    "inTransit": "운송중",
    "errorInbound": "오류입고",
    "cancelRequested": "취소신청",
    "discarded": "폐기"
  },
  "quick_menu": {
    "close": "퀵메뉴 닫기",
    "expand": "퀵메뉴 열기",
    "collapse": "퀵메뉴 접기",
    "title": "서비스 센터",
    "subtitle": "필요한 서비스를 빠르게 선택하세요",
    "services_title": "서비스 바로가기",
    "contact_title": "상담 및 문의",
    "ecommerce_buy": "일반해운 구매대행 신청",
    "ecommerce_delivery": "일반해운 배송대행 신청",
    "lcl_buy": "LCL/FCL 구매대행 신청",
    "lcl_delivery": "LCL/FCL 배송대행 신청",
    "rocket_cn_buy": "로켓 구매대행 신청",
    "rocket_cn_delivery": "로켓 배송대행 신청",
    "rocket_kr_inbound": "한국 로켓프로스 신청",
    "china_3pl": "중국수입 3PL 입고 신청",
    "korea_3pl": "한국 3PL 입고 신청",
    "korea_3pl_outbound": "3PL 출고 신청",
    "coupang_return": "쿠팡 회송·반출 신청",
    "inventory_outbound_records": "입출고 신청 현황",
    "batch_order": "3PL출고대량등록",
    "china_order_status": "중국센터 주문현황",
    "korea_order_status": "한국센터 주문현황",
    "youtube": "YouTube 유튜브 바로가기",
    "consult_3pl": "3PL・FCL 상담",
    "delivery_consult": "배송대행 상담",
    "buying_consult": "구매대행 상담",
    "wechat": "CHINAONE 고객센터 위챗"
  },
  "header_user_menu": {
    "welcome_back": "다시 오신 것을 환영합니다!",
    "common_services": "자주 찾는 서비스",
    "personal_center": "회원정보",
    "my_orders": "전체주문",
    "bill_management": "청구서 관리",
    "coupon_management": "쿠폰 관리",
    "compensation_deposit_management": "보상 예치금 관리",
    "recharge_records": "예치금 내역",
    "api_settings": "API 설정",
    "language_current": "언어: {language}",
    "messages": "메시지관리",
    "logout_title": "로그아웃",
    "logout_confirm": "현재 계정에서 로그아웃하시겠습니까?"
  },
  "deposit_account": {
    "recharge_title": "충전 정보",
    "refund_title": "환불 정보",
    "receiving_account": "입금 계좌",
    "label": "예치금 구분 선택",
    "placeholder": "예치금 구분을 선택하세요",
    "china": "중국 예치금",
    "korea": "한국 예치금",
    "china_balance": "중국 예치금",
    "korea_balance": "한국 예치금",
    "charge": "충전",
    "copied": "복사되었습니다",
    "required": "예치금 구분을 선택하세요",
    "refund_exceeds_balance": "환불 금액은 현재 예치금 잔액(₩{balance})을 초과할 수 없습니다",
    "type_cn": "중국 예칙금 신청",
    "type_kr": "한국 예치금 신청",
    "type_title": "예치금 구분",
    "type": "구분",
    "wallet_cn": "중국 예치금",
    "wallet_kr": "한국 예치금"
  },
  "customer_service_index": {
    "use_guide": "이용안내 상담",
    "buy_service": "구매대행 상담",
    "delivery_service": "배송대행 상담",
    "work_time": "상담시간",
    "mon_fri": "월~금요일",
    "sat": "토요일",
    "free_time": "점심",
    "main_phone": "대표전화"
  },
  "home_logistics": {
    "delivery_tracking": "배송조회",
    "china_tracking": "중국배송조회",
    "korea_tracking": "한국배송조회",
    "sailing_schedule": "출항스케줄",
    "times": "회",
    "schedule_days": "월요일~금요일, 일요일",
    "deadline_title": "입금마감 시간 안내",
    "shipping_days": "운송: 월·수·목·금요일",
    "closed_days": "휴무: 토요일 및 공휴일"
  },
  "stock_preview": {
    "download_scope_hint": "상품을 선택하면 해당 상품의 상세 내역을 확인할 수 있습니다. 선택하지 않으면 현재 창고의 전체 상품을 표시합니다.",
    "inbound": "입고 상세 내역",
    "outbound": "출고 상세 내역",
    "stock": "재고 상세 내역",
    "warehouse": "창고",
    "sku": "SKU ID",
    "spu": "로그인 상품 ID",
    "barcode": "상품 바코드",
    "product": "상품명",
    "option": "옵션명",
    "quantity": "수량",
    "order": "주문번호",
    "enable_time": "사용 가능 시간",
    "spec": "포장 규격",
    "cbm": "CBM",
    "weight": "무게 (kg)",
    "out_time": "출고 시간",
    "goods": "상품 ID",
    "recipient": "수취인",
    "address": "주소",
    "tracking": "운송장 번호",
    "option_id": "상품 옵션 ID",
    "stock_qty": "재고 수량",
    "out_qty": "출고 수량",
    "selected_scope": "선택한 SKU {count}개로 제한",
    "all_scope": "현재 창고의 전체 상품"
  },
  "storage_fee_export": {
    "all_warehouses": "전체 창고",
    "all_nations": "전체 국가",
    "china": "중국",
    "korea": "한국",
    "title": "보관료 상세 내역",
    "select_date": "검색 날짜 선택",
    "start_date": "시작일",
    "end_date": "종료일",
    "select_date_warning": "검색 날짜를 선택하세요",
    "file_name": "보관료 상세 내역",
    "download_failed": "다운로드에 실패했습니다",
    "date_order_warning": "시작일은 종료일보다 늦을 수 없습니다",
    "search_failed": "조회에 실패했습니다",
    "list": "보관료 내역",
    "date": "날짜",
    "warehouse": "재고 창고",
    "bill": "청구서 번호",
    "box_count": "과금 박스 수",
    "quantity": "상품 총수량",
    "volume": "재고 상품 부피",
    "fee": "당일 보관료 (원)"
  },
  "order_fees": {
    "fee_amount": "비용 금액",
    "total_goods_purchase_cost": "상품 총 구매비용",
    "orange_fire_storage_fee": "로켓보관비",
    "warehouse_storage_fee": "재고보관비",
    "original_bill_number": "원 청구서 번호",
    "view_original_bill": "원 청구서 보기",
    "storage_volume_label": "보관비 계산 부피",
    "exchange_rate": "환율",
    "coupon_amount": "쿠폰 금액",
    "refund_details": "환불 상세",
    "refund_wallet": "예치금 반환",
    "refund_bonus": "보상 예치금 반환",
    "refund_points": "포인트 반환",
    "refund_coupon": "쿠폰 반환",
    "refund_total": "환불 합계",
    "view_details": "상세 보기",
    "collapse_details": "상세 접기"
  },
  "upload_file": {
    "button": "파일 업로드",
    "size_limit": "파일 크기는 {size}MB를 초과할 수 없습니다",
    "delete_success": "삭제되었습니다",
    "delete_failed": "삭제에 실패했습니다"
  },
  "receive_address": {
    "set_default_success": "기본 주소로 설정되었습니다",
    "cancel_default_success": "기본 주소 설정이 해제되었습니다",
    "delete_confirm": "【{name}】 수취 주소를 삭제하시겠습니까?",
    "delete_title": "삭제 확인",
    "delete_success": "삭제되었습니다"
  },
  "express_package": {
    "quantity_exceeded": "조합 수량을 초과할 수 없습니다",
    "enter_quantity": "수량을 입력하세요",
    "select_product": "상품을 하나 이상 선택하세요"
  },
  "kr_address_search": {
    "enter_keyword": "주소 검색어를 입력하세요",
    "no_results": "일치하는 주소를 찾을 수 없습니다",
    "search_failed": "주소 검색에 실패했습니다"
  },
  "account_security": {
    "title": "계정 보안",
    "login_password": "로그인 비밀번호",
    "description": "계정 보안을 위해 비밀번호를 정기적으로 변경해 주세요. 비밀번호 변경 전 휴대전화 인증이 필요합니다.",
    "dialog_title": "로그인 비밀번호 변경",
    "sms_verification": "문자 인증",
    "set_new_password": "새 비밀번호 설정",
    "phone_tip": "계정 보안을 위해 현재 등록된 휴대전화 번호를 인증해 주세요. 인증번호가 다음 번호로 전송됩니다:",
    "mobile_number": "휴대전화 번호",
    "sms_code": "문자 인증번호",
    "sms_code_placeholder": "문자 인증번호를 입력하세요",
    "get_verify_code": "인증번호 받기",
    "new_password": "새 비밀번호",
    "new_password_placeholder": "새 비밀번호를 입력하세요",
    "confirm_new_password": "새 비밀번호 확인",
    "confirm_new_password_placeholder": "새 비밀번호를 다시 입력하세요",
    "confirm_change": "변경 확인",
    "code_sent": "인증번호가 전송되었습니다",
    "sms_code_required": "문자 인증번호를 입력해 주세요",
    "new_password_required": "새 비밀번호를 입력해 주세요",
    "confirm_password_required": "새 비밀번호를 다시 입력해 주세요",
    "password_mismatch": "새 비밀번호가 일치하지 않습니다",
    "change_success": "비밀번호가 변경되었습니다"
  },
  "cooperation": {
    "title": "협업관리",
    "member_name": "회원명",
    "member_code": "사서함번호",
    "invited_total": "피추천인",
    "outbound_total": "누적출고건수",
    "performance_total": "누적정산금액",
    "commission_total": "정산예정금액",
    "commission_details": "나의 정산내역",
    "performance_details": "실적내역",
    "receiving_account": "계좌정보",
    "bank_name": "은행명",
    "bank_account": "계좌번호",
    "account_holder": "예금주",
    "verify_code": "인증번호",
    "get_verify_code": "인증번호 받기",
    "change_bank_account": "입금계좌 변경",
    "verify_code_sent": "인증번호가 전송되었습니다",
    "complete_bank_form": "은행 계좌 정보와 인증번호를 모두 입력해 주세요",
    "year": "년",
    "month": "월",
    "month_unit": "월",
    "outbound_completed": "출고완료",
    "performance_amount": "실적금액",
    "commission_amount": "실적",
    "settled": "정산완료",
    "pending_settlement": "정산대기",
    "transfer_receipt": "증빙서류",
    "view_info": "정보보기",
    "detail": "상세",
    "outbound_date": "출고일",
    "subtotal": "소계",
    "performance": "실적",
    "total": "합계",
    "start_date": "시작일",
    "end_date": "종료일",
    "recommend_code": "추천코드",
    "settlement_amount": "결제금액",
    "bind_date": "추천일",
    "number": "No",
    "bank_verify_title": "은행 계좌 변경 인증",
    "bank_verify_tip": "계좌 보안을 위해 먼저 본인 인증을 완료해 주세요.",
    "bank_verify_phone_tip": "계좌 보안을 위해 인증번호가 현재 등록된 휴대전화 번호로 전송됩니다:",
    "enter_verify_code": "인증번호를 입력하세요",
    "change": "변경",
    "complete_bank_account": "은행 계좌 정보를 모두 입력해 주세요"
  },
  "ecommerce_sync": {
    "title": "쿠팡 상품 동기화",
    "account": "쇼핑몰 플랫폼 계정",
    "select_account": "플랫폼 계정을 선택하세요",
    "no_api_account": "Coupang API가 등록되지 않았습니다",
    "no_api_notice": "사용 가능한 Coupang 플랫폼 계정이 없습니다. 먼저 API 정보를 등록하고 확인해 주세요.",
    "api_required_title": "Coupang API를 먼저 등록해 주세요",
    "api_required_description": "Coupang API 정보를 등록하고 연결을 확인한 후 이 페이지에서 플랫폼 계정을 선택해 상품을 불러올 수 있습니다.",
    "go_add_api": "API 등록하러 가기",
    "accounts_load_failed": "플랫폼 계정을 불러오지 못했습니다",
    "accounts_load_failed_description": "플랫폼 계정을 가져올 수 없습니다. 네트워크를 확인한 후 다시 시도해 주세요.",
    "retry": "다시 불러오기",
    "pull_products": "상품 불러오기",
    "notice": "API 관리 페이지에서 API 정보를 등록하고 플랫폼 스토어 연동을 완료해야 상품을 동기화할 수 있습니다. 연동 후에도 동기화되지 않으면 고객센터로 문의해 주세요.",
    "pending_products": "등록 대기 상품",
    "summary": "총 {products}개 상품, {skus}개 SKU",
    "empty": "플랫폼 계정을 선택한 후 상품을 불러오세요",
    "product_and_option": "상품명/옵션명",
    "barcode_id": "상품 바코드 ID",
    "no_image": "이미지 없음",
    "platform_product_name": "플랫폼 상품명",
    "search_customs_item": "통관 품목 검색",
    "select_customs_item": "통관 품목을 선택하세요",
    "product_name_en": "영문 상품명",
    "load_next": "다음 페이지 불러오기",
    "all_loaded": "모든 상품을 불러왔습니다",
    "pull_success": "상품 {count}개를 불러왔습니다",
    "no_products": "불러올 상품이 없습니다",
    "register_success": "상품 등록이 완료되었습니다",
    "register_failed": "상품 등록에 실패했습니다",
    "validation": {
      "product_name": "상품 {product}의 상품명을 입력하세요",
      "keep_sku": "상품 {product}에 최소 하나의 SKU가 필요합니다",
      "platform_product_name": "상품 {product}의 SKU {sku} 플랫폼 상품명을 입력하세요",
      "barcode": "상품 {product}의 SKU {sku} 상품 바코드를 입력하세요",
      "composition": "상품 {product}의 SKU {sku}에 상품 구성이 없습니다",
      "customs_item": "상품 {product}의 SKU {sku} 통관 품목을 선택하세요",
      "product_name_en": "상품 {product}의 SKU {sku} 영문 상품명을 입력하세요"
    }
  },
  "api_settings": {
    "title": "API 관리",
    "description": "주문 동기화, 물류 및 관련 업무 데이터 연동을 위한 외부 쇼핑몰 API를 관리합니다.",
    "add_api": "API 추가",
    "added": "등록 계정",
    "connected": "정상 연결",
    "abnormal": "오류",
    "all_platforms": "전체 플랫폼",
    "all_statuses": "전체 상태",
    "platform": "플랫폼",
    "client_id": "업체 코드 / Client ID",
    "access_key": "Access Key / Client Key",
    "secret_key": "Secret Key",
    "credential_expire_time": "자격 증명 유효기간",
    "credential_expire_placeholder": "플랫폼에 표시된 만료 시간을 선택하세요",
    "credential_expire_help": "Key/Secret 및 Token은 이 시간을 기준으로 정상, 만료 임박 또는 만료 상태를 판단합니다. 플랫폼에서 제공하지 않으면 비워 둘 수 있습니다.",
    "no_expire_time": "유효기간 미제공",
    "enable": "사용",
    "enabled": "사용",
    "connection_status": "연결 상태",
    "last_test_time": "최근 확인 시간",
    "actions": "작업",
    "edit": "수정",
    "test": "테스트",
    "testing": "테스트 중",
    "delete": "삭제",
    "status_connected": "정상",
    "status_failed": "오류",
    "status_untested": "미테스트",
    "status_disabled": "중지",
    "empty": "등록된 플랫폼 계정이 없습니다.",
    "mask_tip": "민감한 키는 마스킹하여 표시됩니다. 수정 시 전체 Secret Key를 다시 표시하지 않습니다.",
    "load_failed": "플랫폼 계정을 불러오지 못했습니다.",
    "add_dialog_title": "API 추가",
    "edit_dialog_title": "{platform} API 수정",
    "company_code": "업체 코드",
    "company_code_placeholder": "업체 코드를 입력해 주세요.",
    "company_code_help": "{platform} 업체 식별 코드입니다.",
    "access_key_placeholder": "Access Key를 입력해 주세요.",
    "secret_key_placeholder": "Secret Key를 입력해 주세요.",
    "key_unchanged_placeholder": "변경하지 않으려면 비워 두세요.",
    "secret_key_help": "Secret Key는 암호화되어 저장되며 저장 후에는 마스킹하여 표시됩니다.",
    "test_connection": "연결 테스트",
    "test_untested": "API 연결을 확인하지 않았습니다.",
    "test_untested_help": "저장하기 전에 인증 정보가 유효한지 테스트하는 것을 권장합니다.",
    "test_success": "API 연결 정상",
    "test_success_help": "플랫폼 API 인증 정보 확인에 성공했습니다.",
    "test_failed": "API 연결 실패",
    "test_failed_help": "업체 코드와 API 키를 확인한 후 다시 시도해 주세요.",
    "required_field": "필수 입력 항목입니다.",
    "cancel": "취소",
    "save": "저장",
    "save_success": "플랫폼 계정이 추가되었습니다.",
    "save_failed": "플랫폼 계정을 추가하지 못했습니다.",
    "detail_load_failed": "플랫폼 계정 상세 정보를 불러오지 못했습니다.",
    "update_success": "플랫폼 계정이 수정되었습니다.",
    "update_failed": "플랫폼 계정을 수정하지 못했습니다.",
    "enable_success": "플랫폼 API가 활성화되었습니다.",
    "disable_success": "플랫폼 API가 중지되었습니다.",
    "enable_update_failed": "사용 상태를 변경하지 못했습니다.",
    "delete_confirm": "{platform} 플랫폼 계정 “{account}”을(를) 삭제하시겠습니까?",
    "delete_success": "플랫폼 계정이 삭제되었습니다.",
    "delete_failed": "플랫폼 계정을 삭제하지 못했습니다."
  },
  "kakao_oauth": {
    "processing_title": "Kakao 로그인 처리 중",
    "processing_hint": "잠시만 기다려 주세요. 이 창을 닫지 마세요.",
    "link_accounts_aria": "ChinaOne 계정과 Kakao 계정 연결",
    "first_login_title": "Kakao 첫 로그인",
    "bind_intro": "가입된 ChinaOne 회원 계정을 인증해 주세요. 연동 후에는 Kakao로 바로 로그인할 수 있습니다.",
    "verify_method_aria": "인증 방법 선택",
    "mobile_verification": "휴대폰 인증",
    "email_verification": "이메일 인증",
    "mobile_placeholder": "가입된 휴대폰 번호를 입력해 주세요",
    "email_placeholder": "가입된 이메일을 입력해 주세요",
    "code_placeholder": "인증번호를 입력해 주세요",
    "get_code": "인증번호 받기",
    "countdown": "{seconds}초",
    "bind_and_login": "인증 후 연동 로그인",
    "no_account": "ChinaOne 계정이 없으신가요?",
    "register_first": "먼저 회원가입",
    "register_tip": "회원가입 후 Kakao 로그인을 다시 눌러 계정을 연동해 주세요.",
    "login_failed_title": "Kakao 로그인 실패",
    "return_login": "로그인으로 돌아가기",
    "invalid_callback": "Kakao 로그인 콜백 정보가 올바르지 않습니다. 다시 로그인해 주세요.",
    "login_failed_default": "Kakao 로그인에 실패했습니다. 다시 시도해 주세요.",
    "authorization_cancelled": "Kakao 인증을 취소했습니다.",
    "authorization_failed": "Kakao 인증에 실패했습니다.",
    "mobile_required": "휴대폰 번호를 입력해 주세요",
    "mobile_invalid": "올바른 한국 휴대폰 번호를 입력해 주세요",
    "email_required": "이메일을 입력해 주세요",
    "email_invalid": "올바른 이메일 주소를 입력해 주세요",
    "code_sent": "인증번호를 전송했습니다",
    "code_send_failed": "인증번호를 전송하지 못했습니다",
    "get_code_first": "먼저 인증번호를 받아 주세요",
    "target_changed": "{target}이(가) 변경되었습니다. 인증번호를 다시 받아 주세요.",
    "mobile": "휴대폰 번호",
    "email": "이메일",
    "code_required": "인증번호를 입력해 주세요",
    "bind_failed": "계정 연동에 실패했습니다. 다시 시도해 주세요"
  },
  "bbs": {
    "notice_description": "최신 공지, 자주 묻는 질문과 다양한 이벤트 정보를 확인해 주세요.",
    "notice_center": "공지 센터",
    "notice_center_description": "확인할 공지 분류를 선택해 주세요.",
    "notice_category_count": "총 {count}개 분류",
    "notice_category_hint": "이 분류의 공지 내용 보기",
    "notice_category_empty": "등록된 공지 분류가 없습니다",
    "notice_category_load_failed": "공지 분류를 불러오지 못했습니다. 잠시 후 다시 시도해 주세요.",
    "home": "홈",
    "detail": "공지 상세",
    "breadcrumb": "현재 위치"
  },
  "package_product_register": {
    "confirm_title": "신청 확인",
    "use_coupang_barcode_as_sku": "Coupang 바코드를 SKU ID로 사용하시겠습니까?",
    "select_product": "등록할 상품을 먼저 선택해 주세요",
    "missing_platform_info": "조합 {code}의 플랫폼 상품 정보가 올바르지 않습니다. 먼저 수정해 주세요",
    "user_missing": "사용자 정보를 확인할 수 없어 상품을 등록할 수 없습니다",
    "success": "상품 등록이 완료되었습니다. 상품 관리에서 확인할 수 있습니다",
    "failed": "상품 등록에 실패했습니다"
  },
  "parcelStatus": {
    "pendingInbound": "입고예정",
    "signed": "센터도착",
    "inbound": "입고완료"
  },
  "history_order": {
    "search_code": "주문 번호 / 상품 번호 / SKU ID / 상품 바코드",
    "basic_product": "기본상품",
    "registered_product": "등록상품",
    "stock_product": "재고상품",
    "stock_selection_tip": "재고 상품은 [ 재고상품 불러오기] 기능을 이요해 주세요.",
    "basic_product_tip": "선택한 상품은 기본상품으로 주문서에 추가됩니다. 등록상품 정보를 이용하려면 [등록상품 불러오기] 기능을 이용해 주세요.",
    "order_code": "주문 번호",
    "goods_code": "상품 번호",
    "sku_id": "SKU ID",
    "start_date": "시작 날짜",
    "end_date": "종료 날짜",
    "empty": "이전 주문이 없습니다",
    "order_fallback": "주문",
    "expand": "상품 선택",
    "collapse": "상품 접기",
    "select_col": "선택",
    "image_col": "이미지",
    "goods_col": "상품 정보",
    "option_col": "색상 / 사이즈",
    "no_image": "이미지 없음",
    "goods_code_label": "상품 번호",
    "sku_label": "SKU",
    "barcode_label": "바코드",
    "selected_summary": "상품 {count}건 선택됨",
    "scope_tip": "현재 주문 페이지와 동일한 창고·운송 방식의 이전 주문만 표시됩니다",
    "select_first": "채울 상품을 먼저 선택해 주세요",
    "opener_closed": "주문 페이지가 닫혔거나 사용할 수 없어 상품을 채울 수 없습니다"
  }
}
